import {
  JsonToBoolean,
  JsonToDouble,
  JsonToInt32,
  JsonToInt64,
  JsonToString,
  JsonToList,
  ArrayToJson,
  JsonToMap,
  MapToJson,
} from '../Helper/Converter';
import * as dcei_wildsky_common_proto from './dcei_wildsky_common_proto';
class MarketData_BindingTournament {
  get descriptor() {
    return MarketData_BindingTournament.descriptor;
  }
  constructor(other) {
    if (other != null) {
      Object.assign(this, other);
      return;
    }
    this._hasTournamentName = false;
    this._tournamentName = null;
  }
  isEmpty() {
    if (this._hasTournamentName) return false;
    return true;
  }
  static fromAny(value) {
    if (value instanceof MarketData_BindingTournament) {
      return value;
    }
    return MarketData_BindingTournament.fromJson(value);
  }
  static fromJson(json) {
    const result = new MarketData_BindingTournament();
    if (json.tournamentName != null) {
      result._hasTournamentName = true;
      result._tournamentName = JsonToString.fromJson(json.tournamentName);
    }
    return result;
  }
  static toJson(value) {
    return value.toJson();
  }
  toJson() {
    const result = {};
    if (this._hasTournamentName) {
      result.tournamentName = JsonToString.toJson(this._tournamentName);
    }
    return result;
  }
  /**
   * @returns {string}
   */
  get tournamentName() {
    return this._hasTournamentName ? this._tournamentName : JsonToString.default;
  }
  get hasTournamentName() {
    return this._hasTournamentName;
  }
  setTournamentName(path, value) {
    return {type: 'SET', path: path.concat(['tournamentName']), value};
  }
  deleteTournamentName(path) {
    return {type: 'DELETE', path: path.concat(['tournamentName'])};
  }
  apply(type, path, value) {
    if (path.length === 0) {
      return this;
    }
    switch (path[0]) {
      case "tournamentName": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new MarketData_BindingTournament(this);
              copy._hasTournamentName = true;
              copy._tournamentName = JsonToString.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasTournamentName) {
                return this;
              }
              const copy = new MarketData_BindingTournament(this);
              copy._hasTournamentName = false;
              copy._tournamentName = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      default:
        return this;
    }
  }
  /**
   * @param {MarketData_BindingTournament} other
   * @returns {MarketData_BindingTournament}
   */
  merge(other) {
    const copy = new MarketData_BindingTournament(this);
    if (other._hasTournamentName) {
      copy._hasTournamentName = true;
      copy._tournamentName = other._tournamentName;
    }
    return copy;
  }
}
MarketData_BindingTournament.default = new MarketData_BindingTournament();
class MarketData_BindingTournament_Builder {
  constructor(value) {
    this._value = new MarketData_BindingTournament(value);
  }
  build() {
    return new MarketData_BindingTournament(this._value);
  }
  setTournamentName(value) {
    this._value._hasTournamentName = true;
    this._value._tournamentName = value;
    return this;
  }
  deleteTournamentName() {
    this._value._hasTournamentName = false;
    this._value._tournamentName = null;
    return this;
  }
}
MarketData_BindingTournament.Builder = MarketData_BindingTournament_Builder;
class MarketData_BindingTournament_WithParent {
  /**
   * @param {MarketData_BindingTournament} value
   * @param {MarketData_BindingTournament_WithParent} parent
   */
  constructor(value, parent) {
    this._value = value;
    this._parent = parent || null;
  }
  get descriptor() {
    return MarketData_BindingTournament.descriptor;
  }
  get selfValue() {
    return this._value;
  }
  get parentValue() {
    return this._parent;
  }
  get hasTournamentName() {
    if (this._cachedHasTournamentName === undefined) {
      if (this._value.hasTournamentName) {
        this._cachedHasTournamentName = true;
      } else {
        this._cachedHasTournamentName = this._parent ? this._parent.hasTournamentName : false;
      }
    }
    return this._cachedHasTournamentName;
  }
  get tournamentName() {
    if (this._cachedTournamentName === undefined) {
      if (this._value.hasTournamentName) {
        this._cachedTournamentName = this._value.tournamentName;
      } else {
        this._cachedTournamentName = this._parent ? this._parent.tournamentName : this._value.tournamentName;
      }
    }
    return this._cachedTournamentName;
  }
  update(current, parent) {
    const result = new MarketData_BindingTournament_WithParent(current, parent);
    return result;
  }
}
MarketData_BindingTournament_WithParent.default = new MarketData_BindingTournament_WithParent(MarketData_BindingTournament.default, null);
MarketData_BindingTournament.WithParent = MarketData_BindingTournament_WithParent;
class MarketData_BindingTournament_Descriptor {
  get tournamentName() {
    if (!this._tournamentName) {
      this._tournamentName = {
        name: "tournamentName",
        Name: "TournamentName",
        number: 1,
        protoType: 9,
        protoName: "tournament_name",
        type: JsonToString,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._tournamentName;
  }
  get fields() {
    if (!this._fields) {
      this._fields = [
        this.tournamentName,
      ];
    }
    return this._fields;
  }
  get oneofs() {
    if (!this._oneofs) {
      this._oneofs = [];
      this._oneofs.push({
        name: "dummyOneofForTournamentName",
        Name: "DummyOneofForTournamentName",
        fields: [
          this.fields[0],
        ],
      });
    }
    return this._oneofs;
  }
}
MarketData_BindingTournament.descriptor = new MarketData_BindingTournament_Descriptor();
class MarketData_Filter {
  get descriptor() {
    return MarketData_Filter.descriptor;
  }
  constructor(other) {
    if (other != null) {
      Object.assign(this, other);
      return;
    }
    this._hasPlayerLevel = false;
    this._playerLevel = null;
    this._openDays = [];
    this._bindingEventKeys = [];
    this._bindingTournaments = [];
  }
  isEmpty() {
    if (this._hasPlayerLevel && !this._playerLevel.isEmpty()) return false;
    if (this._openDays.length > 0) return false;
    if (this._bindingEventKeys.length > 0) return false;
    if (this._bindingTournaments.length > 0) return false;
    return true;
  }
  static fromAny(value) {
    if (value instanceof MarketData_Filter) {
      return value;
    }
    return MarketData_Filter.fromJson(value);
  }
  static fromJson(json) {
    const result = new MarketData_Filter();
    if (json.playerLevel != null) {
      result._hasPlayerLevel = true;
      result._playerLevel = dcei_wildsky_common_proto.IntRange.fromJson(json.playerLevel);
    }
    result._openDays = JsonToList(json.openDays, JsonToString);
    result._bindingEventKeys = JsonToList(json.bindingEventKeys, JsonToString);
    result._bindingTournaments = JsonToList(json.bindingTournaments, MarketData_BindingTournament);
    return result;
  }
  static toJson(value) {
    return value.toJson();
  }
  toJson() {
    const result = {};
    if (this._hasPlayerLevel && !this._playerLevel.isEmpty()) {
      result.playerLevel = dcei_wildsky_common_proto.IntRange.toJson(this._playerLevel);
    }
    if (this._openDays.length > 0) {
      result.openDays = ArrayToJson(this._openDays, JsonToString);
    }
    if (this._bindingEventKeys.length > 0) {
      result.bindingEventKeys = ArrayToJson(this._bindingEventKeys, JsonToString);
    }
    if (this._bindingTournaments.length > 0) {
      result.bindingTournaments = ArrayToJson(this._bindingTournaments, MarketData_BindingTournament);
    }
    return result;
  }
  /**
   * @returns {dcei_wildsky_common_proto.IntRange}
   */
  get playerLevel() {
    return this._hasPlayerLevel ? this._playerLevel : dcei_wildsky_common_proto.IntRange.default;
  }
  get hasPlayerLevel() {
    return this._hasPlayerLevel;
  }
  setPlayerLevel(path, value) {
    return {type: 'SET', path: path.concat(['playerLevel']), value: value.toJson()};
  }
  deletePlayerLevel(path) {
    return {type: 'DELETE', path: path.concat(['playerLevel'])};
  }
  /**
   * @returns {string[]}
   */
  get openDays() {
    return this._openDays;
  }
  addOpenDays(path, value) {
    return {type: 'ADD', path: path.concat(['openDays']), value};
  }
  setOpenDays(path, value) {
    return {type: 'SET', path: path.concat(['openDays']), value: ArrayToJson(value, JsonToString)};
  }
  setOpenDaysByIndex(path, key, value) {
    return {type: 'SET', path: path.concat(['openDays', key]), value};
  }
  deleteOpenDays(path) {
    return {type: 'DELETE', path: path.concat(['openDays'])};
  }
  deleteOpenDaysByIndex(path, key) {
    return {type: 'DELETE', path: path.concat(['openDays', key])};
  }
  /**
   * @returns {string[]}
   */
  get bindingEventKeys() {
    return this._bindingEventKeys;
  }
  addBindingEventKeys(path, value) {
    return {type: 'ADD', path: path.concat(['bindingEventKeys']), value};
  }
  setBindingEventKeys(path, value) {
    return {type: 'SET', path: path.concat(['bindingEventKeys']), value: ArrayToJson(value, JsonToString)};
  }
  setBindingEventKeysByIndex(path, key, value) {
    return {type: 'SET', path: path.concat(['bindingEventKeys', key]), value};
  }
  deleteBindingEventKeys(path) {
    return {type: 'DELETE', path: path.concat(['bindingEventKeys'])};
  }
  deleteBindingEventKeysByIndex(path, key) {
    return {type: 'DELETE', path: path.concat(['bindingEventKeys', key])};
  }
  /**
   * @returns {MarketData_BindingTournament[]}
   */
  get bindingTournaments() {
    return this._bindingTournaments;
  }
  addBindingTournaments(path, value) {
    return {type: 'ADD', path: path.concat(['bindingTournaments']), value: value.toJson()};
  }
  setBindingTournaments(path, value) {
    return {type: 'SET', path: path.concat(['bindingTournaments']), value: ArrayToJson(value, MarketData_BindingTournament)};
  }
  setBindingTournamentsByIndex(path, key, value) {
    return {type: 'SET', path: path.concat(['bindingTournaments', key]), value: value.toJson()};
  }
  deleteBindingTournaments(path) {
    return {type: 'DELETE', path: path.concat(['bindingTournaments'])};
  }
  deleteBindingTournamentsByIndex(path, key) {
    return {type: 'DELETE', path: path.concat(['bindingTournaments', key])};
  }
  apply(type, path, value) {
    if (path.length === 0) {
      return this;
    }
    switch (path[0]) {
      case "playerLevel": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new MarketData_Filter(this);
              copy._hasPlayerLevel = true;
              copy._playerLevel = dcei_wildsky_common_proto.IntRange.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasPlayerLevel) {
                return this;
              }
              const copy = new MarketData_Filter(this);
              copy._hasPlayerLevel = false;
              copy._playerLevel = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          if (!this._hasPlayerLevel) {
            const copy = new MarketData_Filter(this);
            copy._hasPlayerLevel = true;
            copy._playerLevel = dcei_wildsky_common_proto.IntRange.default.apply(type, path.slice(1), value);
            return copy;
          }
          const newValue = this._playerLevel.apply(type, path.slice(1), value);
          if (newValue === this._playerLevel) {
            return this;
          }
          const copy = new MarketData_Filter(this);
          copy._playerLevel = copy._playerLevel.apply(type, path.slice(1), value);
          return copy;
        }
      }
      case "openDays": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new MarketData_Filter(this);
              copy._openDays = [];        for (let i of value) {
                copy._openDays.push(JsonToString.fromAny(i));
              }
              return copy;
            }
            case 'ADD': {
              const copy = new MarketData_Filter(this);
              copy._openDays = copy._openDays.concat([JsonToString.fromAny(value)]);
              return copy;
            }
            case 'DELETE': {
              if (this._openDays.length === 0) {
                return this;
              }
              const copy = new MarketData_Filter(this);
              copy._openDays = [];
              return copy;
            }
            default:
              return this;
          }
        } else if (path.length === 2) {
          const key = path[1];
          if (key < 0 || key >= this._openDays.length) {
            return this;
          }
          switch (type) {
            case 'SET': {
              const copy = new MarketData_Filter(this);
              copy._openDays = copy._openDays.slice();
              copy._openDays[path[1]] = JsonToString.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              const copy = new MarketData_Filter(this);
              copy._openDays = copy._openDays.slice(0, path[1]).concat(copy._openDays.slice(path[1] + 1));
              return copy;
            }
            default:
              return this;
          }
        } else {
          const key = path[1];
          if (key < 0 || key >= this._openDays.length) {
            return this;
          }
          const oldValue = this._openDays[key];
          const newValue = oldValue.apply(type, path.slice(2), value);
          if (oldValue === newValue) {
            return this;
          }
          const copy = new MarketData_Filter(this);
          copy._openDays = copy._openDays.slice();
          copy._openDays[key] = newValue;
          return copy;
        }
      }
      case "bindingEventKeys": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new MarketData_Filter(this);
              copy._bindingEventKeys = [];        for (let i of value) {
                copy._bindingEventKeys.push(JsonToString.fromAny(i));
              }
              return copy;
            }
            case 'ADD': {
              const copy = new MarketData_Filter(this);
              copy._bindingEventKeys = copy._bindingEventKeys.concat([JsonToString.fromAny(value)]);
              return copy;
            }
            case 'DELETE': {
              if (this._bindingEventKeys.length === 0) {
                return this;
              }
              const copy = new MarketData_Filter(this);
              copy._bindingEventKeys = [];
              return copy;
            }
            default:
              return this;
          }
        } else if (path.length === 2) {
          const key = path[1];
          if (key < 0 || key >= this._bindingEventKeys.length) {
            return this;
          }
          switch (type) {
            case 'SET': {
              const copy = new MarketData_Filter(this);
              copy._bindingEventKeys = copy._bindingEventKeys.slice();
              copy._bindingEventKeys[path[1]] = JsonToString.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              const copy = new MarketData_Filter(this);
              copy._bindingEventKeys = copy._bindingEventKeys.slice(0, path[1]).concat(copy._bindingEventKeys.slice(path[1] + 1));
              return copy;
            }
            default:
              return this;
          }
        } else {
          const key = path[1];
          if (key < 0 || key >= this._bindingEventKeys.length) {
            return this;
          }
          const oldValue = this._bindingEventKeys[key];
          const newValue = oldValue.apply(type, path.slice(2), value);
          if (oldValue === newValue) {
            return this;
          }
          const copy = new MarketData_Filter(this);
          copy._bindingEventKeys = copy._bindingEventKeys.slice();
          copy._bindingEventKeys[key] = newValue;
          return copy;
        }
      }
      case "bindingTournaments": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new MarketData_Filter(this);
              copy._bindingTournaments = [];        for (let i of value) {
                copy._bindingTournaments.push(MarketData_BindingTournament.fromAny(i));
              }
              return copy;
            }
            case 'ADD': {
              const copy = new MarketData_Filter(this);
              copy._bindingTournaments = copy._bindingTournaments.concat([MarketData_BindingTournament.fromAny(value)]);
              return copy;
            }
            case 'DELETE': {
              if (this._bindingTournaments.length === 0) {
                return this;
              }
              const copy = new MarketData_Filter(this);
              copy._bindingTournaments = [];
              return copy;
            }
            default:
              return this;
          }
        } else if (path.length === 2) {
          const key = path[1];
          if (key < 0 || key >= this._bindingTournaments.length) {
            return this;
          }
          switch (type) {
            case 'SET': {
              const copy = new MarketData_Filter(this);
              copy._bindingTournaments = copy._bindingTournaments.slice();
              copy._bindingTournaments[path[1]] = MarketData_BindingTournament.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              const copy = new MarketData_Filter(this);
              copy._bindingTournaments = copy._bindingTournaments.slice(0, path[1]).concat(copy._bindingTournaments.slice(path[1] + 1));
              return copy;
            }
            default:
              return this;
          }
        } else {
          const key = path[1];
          if (key < 0 || key >= this._bindingTournaments.length) {
            return this;
          }
          const oldValue = this._bindingTournaments[key];
          const newValue = oldValue.apply(type, path.slice(2), value);
          if (oldValue === newValue) {
            return this;
          }
          const copy = new MarketData_Filter(this);
          copy._bindingTournaments = copy._bindingTournaments.slice();
          copy._bindingTournaments[key] = newValue;
          return copy;
        }
      }
      default:
        return this;
    }
  }
  /**
   * @param {MarketData_Filter} other
   * @returns {MarketData_Filter}
   */
  merge(other) {
    const copy = new MarketData_Filter(this);
    if (other._hasPlayerLevel) {
      if (copy._hasPlayerLevel) {
        copy._playerLevel = copy.playerLevel.merge(other.playerLevel);
      } else {
        copy._playerLevel = other._playerLevel;
      }
      copy._hasPlayerLevel = true;
    }
    copy._openDays = this._openDays.concat(other._openDays);
    copy._bindingEventKeys = this._bindingEventKeys.concat(other._bindingEventKeys);
    copy._bindingTournaments = this._bindingTournaments.concat(other._bindingTournaments);
    return copy;
  }
}
MarketData_Filter.default = new MarketData_Filter();
class MarketData_Filter_Builder {
  constructor(value) {
    this._value = new MarketData_Filter(value);
  }
  build() {
    return new MarketData_Filter(this._value);
  }
  setPlayerLevel(value) {
    this._value._hasPlayerLevel = true;
    this._value._playerLevel = value;
    return this;
  }
  deletePlayerLevel() {
    this._value._hasPlayerLevel = false;
    this._value._playerLevel = null;
    return this;
  }
  addAllOpenDays(values) {
    this._value._openDays = this._value._openDays.concat(values);
    return this;
  }
  addOpenDays(value) {
    this._value._openDays = this._value._openDays.concat([value]);
    return this;
  }
  setOpenDays(index, value) {
    this._value._openDays = this._value._openDays.concat();
    this._value._openDays[index] = value;
    return this;
  }
  clearOpenDays() {
    this._value._openDays = [];
    return this;
  }
  addAllBindingEventKeys(values) {
    this._value._bindingEventKeys = this._value._bindingEventKeys.concat(values);
    return this;
  }
  addBindingEventKeys(value) {
    this._value._bindingEventKeys = this._value._bindingEventKeys.concat([value]);
    return this;
  }
  setBindingEventKeys(index, value) {
    this._value._bindingEventKeys = this._value._bindingEventKeys.concat();
    this._value._bindingEventKeys[index] = value;
    return this;
  }
  clearBindingEventKeys() {
    this._value._bindingEventKeys = [];
    return this;
  }
  addAllBindingTournaments(values) {
    this._value._bindingTournaments = this._value._bindingTournaments.concat(values);
    return this;
  }
  addBindingTournaments(value) {
    this._value._bindingTournaments = this._value._bindingTournaments.concat([value]);
    return this;
  }
  setBindingTournaments(index, value) {
    this._value._bindingTournaments = this._value._bindingTournaments.concat();
    this._value._bindingTournaments[index] = value;
    return this;
  }
  clearBindingTournaments() {
    this._value._bindingTournaments = [];
    return this;
  }
}
MarketData_Filter.Builder = MarketData_Filter_Builder;
class MarketData_Filter_WithParent {
  /**
   * @param {MarketData_Filter} value
   * @param {MarketData_Filter_WithParent} parent
   */
  constructor(value, parent) {
    this._value = value;
    this._parent = parent || null;
  }
  get descriptor() {
    return MarketData_Filter.descriptor;
  }
  get selfValue() {
    return this._value;
  }
  get parentValue() {
    return this._parent;
  }
  get hasPlayerLevel() {
    if (this._cachedHasPlayerLevel === undefined) {
      if (this._value.hasPlayerLevel) {
        this._cachedHasPlayerLevel = true;
      } else {
        this._cachedHasPlayerLevel = this._parent ? this._parent.hasPlayerLevel : false;
      }
    }
    return this._cachedHasPlayerLevel;
  }
  get playerLevel() {
    if (!this._cachedPlayerLevel) {
      if (this._value.hasPlayerLevel) {
        this._cachedPlayerLevel = new dcei_wildsky_common_proto.IntRange.WithParent(this._value.playerLevel, this._parent && this._parent.hasPlayerLevel ? this._parent.playerLevel : null);
      } else {
        this._cachedPlayerLevel = this._parent ? new dcei_wildsky_common_proto.IntRange.WithParent(dcei_wildsky_common_proto.IntRange.default, this._parent.playerLevel) : dcei_wildsky_common_proto.IntRange.WithParent.default;
      }
    }
    return this._cachedPlayerLevel;
  }
  get selfOpenDays() {
    return this._value.openDays;
  }
  get inherentOpenDays() {
    if (!this._inherentOpenDays) {
      this._inherentOpenDays = this._parent ? this._parent.openDays : [];
    }
    return this._inherentOpenDays;
  }
  get openDays() {
    if (!this._allOpenDays) {
      this._allOpenDays = this._parent ? this._parent.openDays.concat(this.selfOpenDays) : this.selfOpenDays;
    }
    return this._allOpenDays;
  }
  get selfBindingEventKeys() {
    return this._value.bindingEventKeys;
  }
  get inherentBindingEventKeys() {
    if (!this._inherentBindingEventKeys) {
      this._inherentBindingEventKeys = this._parent ? this._parent.bindingEventKeys : [];
    }
    return this._inherentBindingEventKeys;
  }
  get bindingEventKeys() {
    if (!this._allBindingEventKeys) {
      this._allBindingEventKeys = this._parent ? this._parent.bindingEventKeys.concat(this.selfBindingEventKeys) : this.selfBindingEventKeys;
    }
    return this._allBindingEventKeys;
  }
  get selfBindingTournaments() {
    if (!this._selfBindingTournaments) {
      this._selfBindingTournaments = [];
      for (let i of this._value.bindingTournaments) {
        this._selfBindingTournaments.push(new MarketData_BindingTournament.WithParent(i, null));
      }
    }
    return this._selfBindingTournaments;
  }
  get inherentBindingTournaments() {
    if (!this._inherentBindingTournaments) {
      this._inherentBindingTournaments = this._parent ? this._parent.bindingTournaments : [];
    }
    return this._inherentBindingTournaments;
  }
  get bindingTournaments() {
    if (!this._allBindingTournaments) {
      this._allBindingTournaments = this._parent ? this._parent.bindingTournaments.concat(this.selfBindingTournaments) : this.selfBindingTournaments;
    }
    return this._allBindingTournaments;
  }
  update(current, parent) {
    const result = new MarketData_Filter_WithParent(current, parent);
    if (this._cachedPlayerLevel && this._value.hasPlayerLevel && current.hasPlayerLevel) {
      if (this._value.playerLevel === current.playerLevel && this._parent === parent) {
        result._cachedPlayerLevel = this._cachedPlayerLevel;
      } else {
        result._cachedPlayerLevel = this._cachedPlayerLevel.update(current.playerLevel, parent && parent.hasPlayerLevel ? parent.playerLevel : null);
      }
    }
    if (this._selfBindingTournaments) {
      if (this._value.bindingTournaments === current.bindingTournaments) {
        result._selfBindingTournaments = this._selfBindingTournaments;
      } else {
        result._selfBindingTournaments = [];
        for (let i = 0; i < current.bindingTournaments.length; i++) {
          const oldValue = this._value.bindingTournaments[i];
          if (oldValue) {
            const oldCache = this._selfBindingTournaments[i];
            if (oldValue === current.bindingTournaments[i]) {
              result._selfBindingTournaments[i] = oldCache;
            } else {
              result._selfBindingTournaments[i] = oldCache.update(current.bindingTournaments[i], null);
            }
          } else {
            result._selfBindingTournaments[i] = new MarketData_BindingTournament.WithParent(current.bindingTournaments[i], null);
          }
        }
      }
    }
    return result;
  }
}
MarketData_Filter_WithParent.default = new MarketData_Filter_WithParent(MarketData_Filter.default, null);
MarketData_Filter.WithParent = MarketData_Filter_WithParent;
class MarketData_Filter_Descriptor {
  get playerLevel() {
    if (!this._playerLevel) {
      this._playerLevel = {
        name: "playerLevel",
        Name: "PlayerLevel",
        number: 1,
        protoType: 11,
        protoName: "player_level",
        type: dcei_wildsky_common_proto.IntRange,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._playerLevel;
  }
  get openDays() {
    if (!this._openDays) {
      this._openDays = {
        name: "openDays",
        Name: "OpenDays",
        number: 2,
        protoType: 9,
        protoName: "open_days",
        type: JsonToString,
        isRepeated: true,
        options: {
          comments: "If none is given, treat it as \"Everyday\"",
          valueDropdown: "DailyQuestOpenDaysStringList",
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._openDays;
  }
  get bindingEventKeys() {
    if (!this._bindingEventKeys) {
      this._bindingEventKeys = {
        name: "bindingEventKeys",
        Name: "BindingEventKeys",
        number: 3,
        protoType: 9,
        protoName: "binding_event_keys",
        type: JsonToString,
        isRepeated: true,
        options: {
          valueDropdown: "MapEventKeys",
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._bindingEventKeys;
  }
  get bindingTournaments() {
    if (!this._bindingTournaments) {
      this._bindingTournaments = {
        name: "bindingTournaments",
        Name: "BindingTournaments",
        number: 4,
        protoType: 11,
        protoName: "binding_tournaments",
        type: MarketData_BindingTournament,
        isRepeated: true,
        options: {
          comments: "tournament market",
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._bindingTournaments;
  }
  get fields() {
    if (!this._fields) {
      this._fields = [
        this.playerLevel,
        this.openDays,
        this.bindingEventKeys,
        this.bindingTournaments,
      ];
    }
    return this._fields;
  }
  get oneofs() {
    if (!this._oneofs) {
      this._oneofs = [];
      this._oneofs.push({
        name: "dummyOneofForPlayerLevel",
        Name: "DummyOneofForPlayerLevel",
        fields: [
          this.fields[0],
        ],
      });
    }
    return this._oneofs;
  }
}
MarketData_Filter.descriptor = new MarketData_Filter_Descriptor();
class MarketData_TabRefreshInfo {
  get descriptor() {
    return MarketData_TabRefreshInfo.descriptor;
  }
  constructor(other) {
    if (other != null) {
      Object.assign(this, other);
      return;
    }
    this._hasDisableAutoRefresh = false;
    this._disableAutoRefresh = null;
    this._hasDisableManualRefresh = false;
    this._disableManualRefresh = null;
    this._autoRefreshTime = [];
    this._hasRefreshCurrency = false;
    this._refreshCurrency = null;
    this._hasRefreshCost = false;
    this._refreshCost = null;
    this._hasMultiplyRefreshCostBy = false;
    this._multiplyRefreshCostBy = null;
  }
  isEmpty() {
    if (this._hasDisableAutoRefresh) return false;
    if (this._hasDisableManualRefresh) return false;
    if (this._autoRefreshTime.length > 0) return false;
    if (this._hasRefreshCurrency) return false;
    if (this._hasRefreshCost) return false;
    if (this._hasMultiplyRefreshCostBy) return false;
    return true;
  }
  static fromAny(value) {
    if (value instanceof MarketData_TabRefreshInfo) {
      return value;
    }
    return MarketData_TabRefreshInfo.fromJson(value);
  }
  static fromJson(json) {
    const result = new MarketData_TabRefreshInfo();
    if (json.disableAutoRefresh != null) {
      result._hasDisableAutoRefresh = true;
      result._disableAutoRefresh = JsonToBoolean.fromJson(json.disableAutoRefresh);
    }
    if (json.disableManualRefresh != null) {
      result._hasDisableManualRefresh = true;
      result._disableManualRefresh = JsonToBoolean.fromJson(json.disableManualRefresh);
    }
    result._autoRefreshTime = JsonToList(json.autoRefreshTime, JsonToInt32);
    if (json.refreshCurrency != null) {
      result._hasRefreshCurrency = true;
      result._refreshCurrency = JsonToString.fromJson(json.refreshCurrency);
    }
    if (json.refreshCost != null) {
      result._hasRefreshCost = true;
      result._refreshCost = JsonToInt32.fromJson(json.refreshCost);
    }
    if (json.multiplyRefreshCostBy != null) {
      result._hasMultiplyRefreshCostBy = true;
      result._multiplyRefreshCostBy = JsonToInt32.fromJson(json.multiplyRefreshCostBy);
    }
    return result;
  }
  static toJson(value) {
    return value.toJson();
  }
  toJson() {
    const result = {};
    if (this._hasDisableAutoRefresh) {
      result.disableAutoRefresh = JsonToBoolean.toJson(this._disableAutoRefresh);
    }
    if (this._hasDisableManualRefresh) {
      result.disableManualRefresh = JsonToBoolean.toJson(this._disableManualRefresh);
    }
    if (this._autoRefreshTime.length > 0) {
      result.autoRefreshTime = ArrayToJson(this._autoRefreshTime, JsonToInt32);
    }
    if (this._hasRefreshCurrency) {
      result.refreshCurrency = JsonToString.toJson(this._refreshCurrency);
    }
    if (this._hasRefreshCost) {
      result.refreshCost = JsonToInt32.toJson(this._refreshCost);
    }
    if (this._hasMultiplyRefreshCostBy) {
      result.multiplyRefreshCostBy = JsonToInt32.toJson(this._multiplyRefreshCostBy);
    }
    return result;
  }
  /**
   * @returns {boolean}
   */
  get disableAutoRefresh() {
    return this._hasDisableAutoRefresh ? this._disableAutoRefresh : JsonToBoolean.default;
  }
  get hasDisableAutoRefresh() {
    return this._hasDisableAutoRefresh;
  }
  setDisableAutoRefresh(path, value) {
    return {type: 'SET', path: path.concat(['disableAutoRefresh']), value};
  }
  deleteDisableAutoRefresh(path) {
    return {type: 'DELETE', path: path.concat(['disableAutoRefresh'])};
  }
  /**
   * @returns {boolean}
   */
  get disableManualRefresh() {
    return this._hasDisableManualRefresh ? this._disableManualRefresh : JsonToBoolean.default;
  }
  get hasDisableManualRefresh() {
    return this._hasDisableManualRefresh;
  }
  setDisableManualRefresh(path, value) {
    return {type: 'SET', path: path.concat(['disableManualRefresh']), value};
  }
  deleteDisableManualRefresh(path) {
    return {type: 'DELETE', path: path.concat(['disableManualRefresh'])};
  }
  /**
   * @returns {number[]}
   */
  get autoRefreshTime() {
    return this._autoRefreshTime;
  }
  addAutoRefreshTime(path, value) {
    return {type: 'ADD', path: path.concat(['autoRefreshTime']), value};
  }
  setAutoRefreshTime(path, value) {
    return {type: 'SET', path: path.concat(['autoRefreshTime']), value: ArrayToJson(value, JsonToInt32)};
  }
  setAutoRefreshTimeByIndex(path, key, value) {
    return {type: 'SET', path: path.concat(['autoRefreshTime', key]), value};
  }
  deleteAutoRefreshTime(path) {
    return {type: 'DELETE', path: path.concat(['autoRefreshTime'])};
  }
  deleteAutoRefreshTimeByIndex(path, key) {
    return {type: 'DELETE', path: path.concat(['autoRefreshTime', key])};
  }
  /**
   * @returns {string}
   */
  get refreshCurrency() {
    return this._hasRefreshCurrency ? this._refreshCurrency : JsonToString.default;
  }
  get hasRefreshCurrency() {
    return this._hasRefreshCurrency;
  }
  setRefreshCurrency(path, value) {
    return {type: 'SET', path: path.concat(['refreshCurrency']), value};
  }
  deleteRefreshCurrency(path) {
    return {type: 'DELETE', path: path.concat(['refreshCurrency'])};
  }
  /**
   * @returns {number}
   */
  get refreshCost() {
    return this._hasRefreshCost ? this._refreshCost : JsonToInt32.default;
  }
  get hasRefreshCost() {
    return this._hasRefreshCost;
  }
  setRefreshCost(path, value) {
    return {type: 'SET', path: path.concat(['refreshCost']), value};
  }
  deleteRefreshCost(path) {
    return {type: 'DELETE', path: path.concat(['refreshCost'])};
  }
  /**
   * @returns {number}
   */
  get multiplyRefreshCostBy() {
    return this._hasMultiplyRefreshCostBy ? this._multiplyRefreshCostBy : JsonToInt32.default;
  }
  get hasMultiplyRefreshCostBy() {
    return this._hasMultiplyRefreshCostBy;
  }
  setMultiplyRefreshCostBy(path, value) {
    return {type: 'SET', path: path.concat(['multiplyRefreshCostBy']), value};
  }
  deleteMultiplyRefreshCostBy(path) {
    return {type: 'DELETE', path: path.concat(['multiplyRefreshCostBy'])};
  }
  apply(type, path, value) {
    if (path.length === 0) {
      return this;
    }
    switch (path[0]) {
      case "disableAutoRefresh": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new MarketData_TabRefreshInfo(this);
              copy._hasDisableAutoRefresh = true;
              copy._disableAutoRefresh = JsonToBoolean.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasDisableAutoRefresh) {
                return this;
              }
              const copy = new MarketData_TabRefreshInfo(this);
              copy._hasDisableAutoRefresh = false;
              copy._disableAutoRefresh = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "disableManualRefresh": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new MarketData_TabRefreshInfo(this);
              copy._hasDisableManualRefresh = true;
              copy._disableManualRefresh = JsonToBoolean.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasDisableManualRefresh) {
                return this;
              }
              const copy = new MarketData_TabRefreshInfo(this);
              copy._hasDisableManualRefresh = false;
              copy._disableManualRefresh = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "autoRefreshTime": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new MarketData_TabRefreshInfo(this);
              copy._autoRefreshTime = [];        for (let i of value) {
                copy._autoRefreshTime.push(JsonToInt32.fromAny(i));
              }
              return copy;
            }
            case 'ADD': {
              const copy = new MarketData_TabRefreshInfo(this);
              copy._autoRefreshTime = copy._autoRefreshTime.concat([JsonToInt32.fromAny(value)]);
              return copy;
            }
            case 'DELETE': {
              if (this._autoRefreshTime.length === 0) {
                return this;
              }
              const copy = new MarketData_TabRefreshInfo(this);
              copy._autoRefreshTime = [];
              return copy;
            }
            default:
              return this;
          }
        } else if (path.length === 2) {
          const key = path[1];
          if (key < 0 || key >= this._autoRefreshTime.length) {
            return this;
          }
          switch (type) {
            case 'SET': {
              const copy = new MarketData_TabRefreshInfo(this);
              copy._autoRefreshTime = copy._autoRefreshTime.slice();
              copy._autoRefreshTime[path[1]] = JsonToInt32.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              const copy = new MarketData_TabRefreshInfo(this);
              copy._autoRefreshTime = copy._autoRefreshTime.slice(0, path[1]).concat(copy._autoRefreshTime.slice(path[1] + 1));
              return copy;
            }
            default:
              return this;
          }
        } else {
          const key = path[1];
          if (key < 0 || key >= this._autoRefreshTime.length) {
            return this;
          }
          const oldValue = this._autoRefreshTime[key];
          const newValue = oldValue.apply(type, path.slice(2), value);
          if (oldValue === newValue) {
            return this;
          }
          const copy = new MarketData_TabRefreshInfo(this);
          copy._autoRefreshTime = copy._autoRefreshTime.slice();
          copy._autoRefreshTime[key] = newValue;
          return copy;
        }
      }
      case "refreshCurrency": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new MarketData_TabRefreshInfo(this);
              copy._hasRefreshCurrency = true;
              copy._refreshCurrency = JsonToString.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasRefreshCurrency) {
                return this;
              }
              const copy = new MarketData_TabRefreshInfo(this);
              copy._hasRefreshCurrency = false;
              copy._refreshCurrency = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "refreshCost": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new MarketData_TabRefreshInfo(this);
              copy._hasRefreshCost = true;
              copy._refreshCost = JsonToInt32.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasRefreshCost) {
                return this;
              }
              const copy = new MarketData_TabRefreshInfo(this);
              copy._hasRefreshCost = false;
              copy._refreshCost = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "multiplyRefreshCostBy": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new MarketData_TabRefreshInfo(this);
              copy._hasMultiplyRefreshCostBy = true;
              copy._multiplyRefreshCostBy = JsonToInt32.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasMultiplyRefreshCostBy) {
                return this;
              }
              const copy = new MarketData_TabRefreshInfo(this);
              copy._hasMultiplyRefreshCostBy = false;
              copy._multiplyRefreshCostBy = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      default:
        return this;
    }
  }
  /**
   * @param {MarketData_TabRefreshInfo} other
   * @returns {MarketData_TabRefreshInfo}
   */
  merge(other) {
    const copy = new MarketData_TabRefreshInfo(this);
    if (other._hasDisableAutoRefresh) {
      copy._hasDisableAutoRefresh = true;
      copy._disableAutoRefresh = other._disableAutoRefresh;
    }
    if (other._hasDisableManualRefresh) {
      copy._hasDisableManualRefresh = true;
      copy._disableManualRefresh = other._disableManualRefresh;
    }
    copy._autoRefreshTime = this._autoRefreshTime.concat(other._autoRefreshTime);
    if (other._hasRefreshCurrency) {
      copy._hasRefreshCurrency = true;
      copy._refreshCurrency = other._refreshCurrency;
    }
    if (other._hasRefreshCost) {
      copy._hasRefreshCost = true;
      copy._refreshCost = other._refreshCost;
    }
    if (other._hasMultiplyRefreshCostBy) {
      copy._hasMultiplyRefreshCostBy = true;
      copy._multiplyRefreshCostBy = other._multiplyRefreshCostBy;
    }
    return copy;
  }
}
MarketData_TabRefreshInfo.default = new MarketData_TabRefreshInfo();
class MarketData_TabRefreshInfo_Builder {
  constructor(value) {
    this._value = new MarketData_TabRefreshInfo(value);
  }
  build() {
    return new MarketData_TabRefreshInfo(this._value);
  }
  setDisableAutoRefresh(value) {
    this._value._hasDisableAutoRefresh = true;
    this._value._disableAutoRefresh = value;
    return this;
  }
  deleteDisableAutoRefresh() {
    this._value._hasDisableAutoRefresh = false;
    this._value._disableAutoRefresh = null;
    return this;
  }
  setDisableManualRefresh(value) {
    this._value._hasDisableManualRefresh = true;
    this._value._disableManualRefresh = value;
    return this;
  }
  deleteDisableManualRefresh() {
    this._value._hasDisableManualRefresh = false;
    this._value._disableManualRefresh = null;
    return this;
  }
  addAllAutoRefreshTime(values) {
    this._value._autoRefreshTime = this._value._autoRefreshTime.concat(values);
    return this;
  }
  addAutoRefreshTime(value) {
    this._value._autoRefreshTime = this._value._autoRefreshTime.concat([value]);
    return this;
  }
  setAutoRefreshTime(index, value) {
    this._value._autoRefreshTime = this._value._autoRefreshTime.concat();
    this._value._autoRefreshTime[index] = value;
    return this;
  }
  clearAutoRefreshTime() {
    this._value._autoRefreshTime = [];
    return this;
  }
  setRefreshCurrency(value) {
    this._value._hasRefreshCurrency = true;
    this._value._refreshCurrency = value;
    return this;
  }
  deleteRefreshCurrency() {
    this._value._hasRefreshCurrency = false;
    this._value._refreshCurrency = null;
    return this;
  }
  setRefreshCost(value) {
    this._value._hasRefreshCost = true;
    this._value._refreshCost = value;
    return this;
  }
  deleteRefreshCost() {
    this._value._hasRefreshCost = false;
    this._value._refreshCost = null;
    return this;
  }
  setMultiplyRefreshCostBy(value) {
    this._value._hasMultiplyRefreshCostBy = true;
    this._value._multiplyRefreshCostBy = value;
    return this;
  }
  deleteMultiplyRefreshCostBy() {
    this._value._hasMultiplyRefreshCostBy = false;
    this._value._multiplyRefreshCostBy = null;
    return this;
  }
}
MarketData_TabRefreshInfo.Builder = MarketData_TabRefreshInfo_Builder;
class MarketData_TabRefreshInfo_WithParent {
  /**
   * @param {MarketData_TabRefreshInfo} value
   * @param {MarketData_TabRefreshInfo_WithParent} parent
   */
  constructor(value, parent) {
    this._value = value;
    this._parent = parent || null;
  }
  get descriptor() {
    return MarketData_TabRefreshInfo.descriptor;
  }
  get selfValue() {
    return this._value;
  }
  get parentValue() {
    return this._parent;
  }
  get hasDisableAutoRefresh() {
    if (this._cachedHasDisableAutoRefresh === undefined) {
      if (this._value.hasDisableAutoRefresh) {
        this._cachedHasDisableAutoRefresh = true;
      } else {
        this._cachedHasDisableAutoRefresh = this._parent ? this._parent.hasDisableAutoRefresh : false;
      }
    }
    return this._cachedHasDisableAutoRefresh;
  }
  get disableAutoRefresh() {
    if (this._cachedDisableAutoRefresh === undefined) {
      if (this._value.hasDisableAutoRefresh) {
        this._cachedDisableAutoRefresh = this._value.disableAutoRefresh;
      } else {
        this._cachedDisableAutoRefresh = this._parent ? this._parent.disableAutoRefresh : this._value.disableAutoRefresh;
      }
    }
    return this._cachedDisableAutoRefresh;
  }
  get hasDisableManualRefresh() {
    if (this._cachedHasDisableManualRefresh === undefined) {
      if (this._value.hasDisableManualRefresh) {
        this._cachedHasDisableManualRefresh = true;
      } else {
        this._cachedHasDisableManualRefresh = this._parent ? this._parent.hasDisableManualRefresh : false;
      }
    }
    return this._cachedHasDisableManualRefresh;
  }
  get disableManualRefresh() {
    if (this._cachedDisableManualRefresh === undefined) {
      if (this._value.hasDisableManualRefresh) {
        this._cachedDisableManualRefresh = this._value.disableManualRefresh;
      } else {
        this._cachedDisableManualRefresh = this._parent ? this._parent.disableManualRefresh : this._value.disableManualRefresh;
      }
    }
    return this._cachedDisableManualRefresh;
  }
  get selfAutoRefreshTime() {
    return this._value.autoRefreshTime;
  }
  get inherentAutoRefreshTime() {
    if (!this._inherentAutoRefreshTime) {
      this._inherentAutoRefreshTime = this._parent ? this._parent.autoRefreshTime : [];
    }
    return this._inherentAutoRefreshTime;
  }
  get autoRefreshTime() {
    if (!this._allAutoRefreshTime) {
      this._allAutoRefreshTime = this._parent ? this._parent.autoRefreshTime.concat(this.selfAutoRefreshTime) : this.selfAutoRefreshTime;
    }
    return this._allAutoRefreshTime;
  }
  get hasRefreshCurrency() {
    if (this._cachedHasRefreshCurrency === undefined) {
      if (this._value.hasRefreshCurrency) {
        this._cachedHasRefreshCurrency = true;
      } else {
        this._cachedHasRefreshCurrency = this._parent ? this._parent.hasRefreshCurrency : false;
      }
    }
    return this._cachedHasRefreshCurrency;
  }
  get refreshCurrency() {
    if (this._cachedRefreshCurrency === undefined) {
      if (this._value.hasRefreshCurrency) {
        this._cachedRefreshCurrency = this._value.refreshCurrency;
      } else {
        this._cachedRefreshCurrency = this._parent ? this._parent.refreshCurrency : this._value.refreshCurrency;
      }
    }
    return this._cachedRefreshCurrency;
  }
  get hasRefreshCost() {
    if (this._cachedHasRefreshCost === undefined) {
      if (this._value.hasRefreshCost) {
        this._cachedHasRefreshCost = true;
      } else {
        this._cachedHasRefreshCost = this._parent ? this._parent.hasRefreshCost : false;
      }
    }
    return this._cachedHasRefreshCost;
  }
  get refreshCost() {
    if (this._cachedRefreshCost === undefined) {
      if (this._value.hasRefreshCost) {
        this._cachedRefreshCost = this._value.refreshCost;
      } else {
        this._cachedRefreshCost = this._parent ? this._parent.refreshCost : this._value.refreshCost;
      }
    }
    return this._cachedRefreshCost;
  }
  get hasMultiplyRefreshCostBy() {
    if (this._cachedHasMultiplyRefreshCostBy === undefined) {
      if (this._value.hasMultiplyRefreshCostBy) {
        this._cachedHasMultiplyRefreshCostBy = true;
      } else {
        this._cachedHasMultiplyRefreshCostBy = this._parent ? this._parent.hasMultiplyRefreshCostBy : false;
      }
    }
    return this._cachedHasMultiplyRefreshCostBy;
  }
  get multiplyRefreshCostBy() {
    if (this._cachedMultiplyRefreshCostBy === undefined) {
      if (this._value.hasMultiplyRefreshCostBy) {
        this._cachedMultiplyRefreshCostBy = this._value.multiplyRefreshCostBy;
      } else {
        this._cachedMultiplyRefreshCostBy = this._parent ? this._parent.multiplyRefreshCostBy : this._value.multiplyRefreshCostBy;
      }
    }
    return this._cachedMultiplyRefreshCostBy;
  }
  update(current, parent) {
    const result = new MarketData_TabRefreshInfo_WithParent(current, parent);
    return result;
  }
}
MarketData_TabRefreshInfo_WithParent.default = new MarketData_TabRefreshInfo_WithParent(MarketData_TabRefreshInfo.default, null);
MarketData_TabRefreshInfo.WithParent = MarketData_TabRefreshInfo_WithParent;
class MarketData_TabRefreshInfo_Descriptor {
  get disableAutoRefresh() {
    if (!this._disableAutoRefresh) {
      this._disableAutoRefresh = {
        name: "disableAutoRefresh",
        Name: "DisableAutoRefresh",
        number: 6,
        protoType: 8,
        protoName: "disable_auto_refresh",
        type: JsonToBoolean,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._disableAutoRefresh;
  }
  get disableManualRefresh() {
    if (!this._disableManualRefresh) {
      this._disableManualRefresh = {
        name: "disableManualRefresh",
        Name: "DisableManualRefresh",
        number: 7,
        protoType: 8,
        protoName: "disable_manual_refresh",
        type: JsonToBoolean,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._disableManualRefresh;
  }
  get autoRefreshTime() {
    if (!this._autoRefreshTime) {
      this._autoRefreshTime = {
        name: "autoRefreshTime",
        Name: "AutoRefreshTime",
        number: 1,
        protoType: 5,
        protoName: "auto_refresh_time",
        type: JsonToInt32,
        isRepeated: true,
        options: {
          comments: "Time of day to refresh. This value is total seconds passed from midnight",
          min: 0,
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._autoRefreshTime;
  }
  get refreshCurrency() {
    if (!this._refreshCurrency) {
      this._refreshCurrency = {
        name: "refreshCurrency",
        Name: "RefreshCurrency",
        number: 2,
        protoType: 9,
        protoName: "refresh_currency",
        type: JsonToString,
        options: {
          valueDropdown: "RewardItemKeyList",
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._refreshCurrency;
  }
  get refreshCost() {
    if (!this._refreshCost) {
      this._refreshCost = {
        name: "refreshCost",
        Name: "RefreshCost",
        number: 3,
        protoType: 5,
        protoName: "refresh_cost",
        type: JsonToInt32,
        options: {
          comments: "Initial cost",
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._refreshCost;
  }
  get multiplyRefreshCostBy() {
    if (!this._multiplyRefreshCostBy) {
      this._multiplyRefreshCostBy = {
        name: "multiplyRefreshCostBy",
        Name: "MultiplyRefreshCostBy",
        number: 5,
        protoType: 5,
        protoName: "multiply_refresh_cost_by",
        type: JsonToInt32,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._multiplyRefreshCostBy;
  }
  get fields() {
    if (!this._fields) {
      this._fields = [
        this.disableAutoRefresh,
        this.disableManualRefresh,
        this.autoRefreshTime,
        this.refreshCurrency,
        this.refreshCost,
        this.multiplyRefreshCostBy,
      ];
    }
    return this._fields;
  }
  get oneofs() {
    if (!this._oneofs) {
      this._oneofs = [];
      this._oneofs.push({
        name: "dummyOneofForDisableAutoRefresh",
        Name: "DummyOneofForDisableAutoRefresh",
        fields: [
          this.fields[0],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForDisableManualRefresh",
        Name: "DummyOneofForDisableManualRefresh",
        fields: [
          this.fields[1],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForRefreshCurrency",
        Name: "DummyOneofForRefreshCurrency",
        fields: [
          this.fields[3],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForRefreshCost",
        Name: "DummyOneofForRefreshCost",
        fields: [
          this.fields[4],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForMultiplyRefreshCostBy",
        Name: "DummyOneofForMultiplyRefreshCostBy",
        fields: [
          this.fields[5],
        ],
      });
    }
    return this._oneofs;
  }
}
MarketData_TabRefreshInfo.descriptor = new MarketData_TabRefreshInfo_Descriptor();
class MarketData_Item {
  get descriptor() {
    return MarketData_Item.descriptor;
  }
  constructor(other) {
    if (other != null) {
      Object.assign(this, other);
      return;
    }
    this._hasItemKey = false;
    this._itemKey = null;
    this._hasChancePercentage = false;
    this._chancePercentage = null;
    this._hasCurrencyKey = false;
    this._currencyKey = null;
    this._hasUnitPrice = false;
    this._unitPrice = null;
    this._hasTotalAmount = false;
    this._totalAmount = null;
    this._hasTotalPriceOverride = false;
    this._totalPriceOverride = null;
  }
  isEmpty() {
    if (this._hasItemKey) return false;
    if (this._hasChancePercentage) return false;
    if (this._hasCurrencyKey) return false;
    if (this._hasUnitPrice) return false;
    if (this._hasTotalAmount) return false;
    if (this._hasTotalPriceOverride) return false;
    return true;
  }
  static fromAny(value) {
    if (value instanceof MarketData_Item) {
      return value;
    }
    return MarketData_Item.fromJson(value);
  }
  static fromJson(json) {
    const result = new MarketData_Item();
    if (json.itemKey != null) {
      result._hasItemKey = true;
      result._itemKey = JsonToString.fromJson(json.itemKey);
    }
    if (json.chancePercentage != null) {
      result._hasChancePercentage = true;
      result._chancePercentage = JsonToDouble.fromJson(json.chancePercentage);
    }
    if (json.currencyKey != null) {
      result._hasCurrencyKey = true;
      result._currencyKey = JsonToString.fromJson(json.currencyKey);
    }
    if (json.unitPrice != null) {
      result._hasUnitPrice = true;
      result._unitPrice = JsonToInt32.fromJson(json.unitPrice);
    }
    if (json.totalAmount != null) {
      result._hasTotalAmount = true;
      result._totalAmount = JsonToInt32.fromJson(json.totalAmount);
    }
    if (json.totalPriceOverride != null) {
      result._hasTotalPriceOverride = true;
      result._totalPriceOverride = JsonToInt32.fromJson(json.totalPriceOverride);
    }
    return result;
  }
  static toJson(value) {
    return value.toJson();
  }
  toJson() {
    const result = {};
    if (this._hasItemKey) {
      result.itemKey = JsonToString.toJson(this._itemKey);
    }
    if (this._hasChancePercentage) {
      result.chancePercentage = JsonToDouble.toJson(this._chancePercentage);
    }
    if (this._hasCurrencyKey) {
      result.currencyKey = JsonToString.toJson(this._currencyKey);
    }
    if (this._hasUnitPrice) {
      result.unitPrice = JsonToInt32.toJson(this._unitPrice);
    }
    if (this._hasTotalAmount) {
      result.totalAmount = JsonToInt32.toJson(this._totalAmount);
    }
    if (this._hasTotalPriceOverride) {
      result.totalPriceOverride = JsonToInt32.toJson(this._totalPriceOverride);
    }
    return result;
  }
  /**
   * @returns {string}
   */
  get itemKey() {
    return this._hasItemKey ? this._itemKey : JsonToString.default;
  }
  get hasItemKey() {
    return this._hasItemKey;
  }
  setItemKey(path, value) {
    return {type: 'SET', path: path.concat(['itemKey']), value};
  }
  deleteItemKey(path) {
    return {type: 'DELETE', path: path.concat(['itemKey'])};
  }
  /**
   * @returns {number}
   */
  get chancePercentage() {
    return this._hasChancePercentage ? this._chancePercentage : JsonToDouble.default;
  }
  get hasChancePercentage() {
    return this._hasChancePercentage;
  }
  setChancePercentage(path, value) {
    return {type: 'SET', path: path.concat(['chancePercentage']), value};
  }
  deleteChancePercentage(path) {
    return {type: 'DELETE', path: path.concat(['chancePercentage'])};
  }
  /**
   * @returns {string}
   */
  get currencyKey() {
    return this._hasCurrencyKey ? this._currencyKey : JsonToString.default;
  }
  get hasCurrencyKey() {
    return this._hasCurrencyKey;
  }
  setCurrencyKey(path, value) {
    return {type: 'SET', path: path.concat(['currencyKey']), value};
  }
  deleteCurrencyKey(path) {
    return {type: 'DELETE', path: path.concat(['currencyKey'])};
  }
  /**
   * @returns {number}
   */
  get unitPrice() {
    return this._hasUnitPrice ? this._unitPrice : JsonToInt32.default;
  }
  get hasUnitPrice() {
    return this._hasUnitPrice;
  }
  setUnitPrice(path, value) {
    return {type: 'SET', path: path.concat(['unitPrice']), value};
  }
  deleteUnitPrice(path) {
    return {type: 'DELETE', path: path.concat(['unitPrice'])};
  }
  /**
   * @returns {number}
   */
  get totalAmount() {
    return this._hasTotalAmount ? this._totalAmount : JsonToInt32.default;
  }
  get hasTotalAmount() {
    return this._hasTotalAmount;
  }
  setTotalAmount(path, value) {
    return {type: 'SET', path: path.concat(['totalAmount']), value};
  }
  deleteTotalAmount(path) {
    return {type: 'DELETE', path: path.concat(['totalAmount'])};
  }
  /**
   * @returns {number}
   */
  get totalPriceOverride() {
    return this._hasTotalPriceOverride ? this._totalPriceOverride : JsonToInt32.default;
  }
  get hasTotalPriceOverride() {
    return this._hasTotalPriceOverride;
  }
  setTotalPriceOverride(path, value) {
    return {type: 'SET', path: path.concat(['totalPriceOverride']), value};
  }
  deleteTotalPriceOverride(path) {
    return {type: 'DELETE', path: path.concat(['totalPriceOverride'])};
  }
  apply(type, path, value) {
    if (path.length === 0) {
      return this;
    }
    switch (path[0]) {
      case "itemKey": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new MarketData_Item(this);
              copy._hasItemKey = true;
              copy._itemKey = JsonToString.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasItemKey) {
                return this;
              }
              const copy = new MarketData_Item(this);
              copy._hasItemKey = false;
              copy._itemKey = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "chancePercentage": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new MarketData_Item(this);
              copy._hasChancePercentage = true;
              copy._chancePercentage = JsonToDouble.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasChancePercentage) {
                return this;
              }
              const copy = new MarketData_Item(this);
              copy._hasChancePercentage = false;
              copy._chancePercentage = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "currencyKey": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new MarketData_Item(this);
              copy._hasCurrencyKey = true;
              copy._currencyKey = JsonToString.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasCurrencyKey) {
                return this;
              }
              const copy = new MarketData_Item(this);
              copy._hasCurrencyKey = false;
              copy._currencyKey = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "unitPrice": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new MarketData_Item(this);
              copy._hasUnitPrice = true;
              copy._unitPrice = JsonToInt32.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasUnitPrice) {
                return this;
              }
              const copy = new MarketData_Item(this);
              copy._hasUnitPrice = false;
              copy._unitPrice = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "totalAmount": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new MarketData_Item(this);
              copy._hasTotalAmount = true;
              copy._totalAmount = JsonToInt32.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasTotalAmount) {
                return this;
              }
              const copy = new MarketData_Item(this);
              copy._hasTotalAmount = false;
              copy._totalAmount = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "totalPriceOverride": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new MarketData_Item(this);
              copy._hasTotalPriceOverride = true;
              copy._totalPriceOverride = JsonToInt32.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasTotalPriceOverride) {
                return this;
              }
              const copy = new MarketData_Item(this);
              copy._hasTotalPriceOverride = false;
              copy._totalPriceOverride = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      default:
        return this;
    }
  }
  /**
   * @param {MarketData_Item} other
   * @returns {MarketData_Item}
   */
  merge(other) {
    const copy = new MarketData_Item(this);
    if (other._hasItemKey) {
      copy._hasItemKey = true;
      copy._itemKey = other._itemKey;
    }
    if (other._hasChancePercentage) {
      copy._hasChancePercentage = true;
      copy._chancePercentage = other._chancePercentage;
    }
    if (other._hasCurrencyKey) {
      copy._hasCurrencyKey = true;
      copy._currencyKey = other._currencyKey;
    }
    if (other._hasUnitPrice) {
      copy._hasUnitPrice = true;
      copy._unitPrice = other._unitPrice;
    }
    if (other._hasTotalAmount) {
      copy._hasTotalAmount = true;
      copy._totalAmount = other._totalAmount;
    }
    if (other._hasTotalPriceOverride) {
      copy._hasTotalPriceOverride = true;
      copy._totalPriceOverride = other._totalPriceOverride;
    }
    return copy;
  }
}
MarketData_Item.default = new MarketData_Item();
class MarketData_Item_Builder {
  constructor(value) {
    this._value = new MarketData_Item(value);
  }
  build() {
    return new MarketData_Item(this._value);
  }
  setItemKey(value) {
    this._value._hasItemKey = true;
    this._value._itemKey = value;
    return this;
  }
  deleteItemKey() {
    this._value._hasItemKey = false;
    this._value._itemKey = null;
    return this;
  }
  setChancePercentage(value) {
    this._value._hasChancePercentage = true;
    this._value._chancePercentage = value;
    return this;
  }
  deleteChancePercentage() {
    this._value._hasChancePercentage = false;
    this._value._chancePercentage = null;
    return this;
  }
  setCurrencyKey(value) {
    this._value._hasCurrencyKey = true;
    this._value._currencyKey = value;
    return this;
  }
  deleteCurrencyKey() {
    this._value._hasCurrencyKey = false;
    this._value._currencyKey = null;
    return this;
  }
  setUnitPrice(value) {
    this._value._hasUnitPrice = true;
    this._value._unitPrice = value;
    return this;
  }
  deleteUnitPrice() {
    this._value._hasUnitPrice = false;
    this._value._unitPrice = null;
    return this;
  }
  setTotalAmount(value) {
    this._value._hasTotalAmount = true;
    this._value._totalAmount = value;
    return this;
  }
  deleteTotalAmount() {
    this._value._hasTotalAmount = false;
    this._value._totalAmount = null;
    return this;
  }
  setTotalPriceOverride(value) {
    this._value._hasTotalPriceOverride = true;
    this._value._totalPriceOverride = value;
    return this;
  }
  deleteTotalPriceOverride() {
    this._value._hasTotalPriceOverride = false;
    this._value._totalPriceOverride = null;
    return this;
  }
}
MarketData_Item.Builder = MarketData_Item_Builder;
class MarketData_Item_WithParent {
  /**
   * @param {MarketData_Item} value
   * @param {MarketData_Item_WithParent} parent
   */
  constructor(value, parent) {
    this._value = value;
    this._parent = parent || null;
  }
  get descriptor() {
    return MarketData_Item.descriptor;
  }
  get selfValue() {
    return this._value;
  }
  get parentValue() {
    return this._parent;
  }
  get hasItemKey() {
    if (this._cachedHasItemKey === undefined) {
      if (this._value.hasItemKey) {
        this._cachedHasItemKey = true;
      } else {
        this._cachedHasItemKey = this._parent ? this._parent.hasItemKey : false;
      }
    }
    return this._cachedHasItemKey;
  }
  get itemKey() {
    if (this._cachedItemKey === undefined) {
      if (this._value.hasItemKey) {
        this._cachedItemKey = this._value.itemKey;
      } else {
        this._cachedItemKey = this._parent ? this._parent.itemKey : this._value.itemKey;
      }
    }
    return this._cachedItemKey;
  }
  get hasChancePercentage() {
    if (this._cachedHasChancePercentage === undefined) {
      if (this._value.hasChancePercentage) {
        this._cachedHasChancePercentage = true;
      } else {
        this._cachedHasChancePercentage = this._parent ? this._parent.hasChancePercentage : false;
      }
    }
    return this._cachedHasChancePercentage;
  }
  get chancePercentage() {
    if (this._cachedChancePercentage === undefined) {
      if (this._value.hasChancePercentage) {
        this._cachedChancePercentage = this._value.chancePercentage;
      } else {
        this._cachedChancePercentage = this._parent ? this._parent.chancePercentage : this._value.chancePercentage;
      }
    }
    return this._cachedChancePercentage;
  }
  get hasCurrencyKey() {
    if (this._cachedHasCurrencyKey === undefined) {
      if (this._value.hasCurrencyKey) {
        this._cachedHasCurrencyKey = true;
      } else {
        this._cachedHasCurrencyKey = this._parent ? this._parent.hasCurrencyKey : false;
      }
    }
    return this._cachedHasCurrencyKey;
  }
  get currencyKey() {
    if (this._cachedCurrencyKey === undefined) {
      if (this._value.hasCurrencyKey) {
        this._cachedCurrencyKey = this._value.currencyKey;
      } else {
        this._cachedCurrencyKey = this._parent ? this._parent.currencyKey : this._value.currencyKey;
      }
    }
    return this._cachedCurrencyKey;
  }
  get hasUnitPrice() {
    if (this._cachedHasUnitPrice === undefined) {
      if (this._value.hasUnitPrice) {
        this._cachedHasUnitPrice = true;
      } else {
        this._cachedHasUnitPrice = this._parent ? this._parent.hasUnitPrice : false;
      }
    }
    return this._cachedHasUnitPrice;
  }
  get unitPrice() {
    if (this._cachedUnitPrice === undefined) {
      if (this._value.hasUnitPrice) {
        this._cachedUnitPrice = this._value.unitPrice;
      } else {
        this._cachedUnitPrice = this._parent ? this._parent.unitPrice : this._value.unitPrice;
      }
    }
    return this._cachedUnitPrice;
  }
  get hasTotalAmount() {
    if (this._cachedHasTotalAmount === undefined) {
      if (this._value.hasTotalAmount) {
        this._cachedHasTotalAmount = true;
      } else {
        this._cachedHasTotalAmount = this._parent ? this._parent.hasTotalAmount : false;
      }
    }
    return this._cachedHasTotalAmount;
  }
  get totalAmount() {
    if (this._cachedTotalAmount === undefined) {
      if (this._value.hasTotalAmount) {
        this._cachedTotalAmount = this._value.totalAmount;
      } else {
        this._cachedTotalAmount = this._parent ? this._parent.totalAmount : this._value.totalAmount;
      }
    }
    return this._cachedTotalAmount;
  }
  get hasTotalPriceOverride() {
    if (this._cachedHasTotalPriceOverride === undefined) {
      if (this._value.hasTotalPriceOverride) {
        this._cachedHasTotalPriceOverride = true;
      } else {
        this._cachedHasTotalPriceOverride = this._parent ? this._parent.hasTotalPriceOverride : false;
      }
    }
    return this._cachedHasTotalPriceOverride;
  }
  get totalPriceOverride() {
    if (this._cachedTotalPriceOverride === undefined) {
      if (this._value.hasTotalPriceOverride) {
        this._cachedTotalPriceOverride = this._value.totalPriceOverride;
      } else {
        this._cachedTotalPriceOverride = this._parent ? this._parent.totalPriceOverride : this._value.totalPriceOverride;
      }
    }
    return this._cachedTotalPriceOverride;
  }
  update(current, parent) {
    const result = new MarketData_Item_WithParent(current, parent);
    return result;
  }
}
MarketData_Item_WithParent.default = new MarketData_Item_WithParent(MarketData_Item.default, null);
MarketData_Item.WithParent = MarketData_Item_WithParent;
class MarketData_Item_Descriptor {
  get itemKey() {
    if (!this._itemKey) {
      this._itemKey = {
        name: "itemKey",
        Name: "ItemKey",
        number: 1,
        protoType: 9,
        protoName: "item_key",
        type: JsonToString,
        options: {
          valueDropdown: "RewardItemKeyList",
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._itemKey;
  }
  get chancePercentage() {
    if (!this._chancePercentage) {
      this._chancePercentage = {
        name: "chancePercentage",
        Name: "ChancePercentage",
        number: 2,
        protoType: 1,
        protoName: "chance_percentage",
        type: JsonToDouble,
        options: {
          propertyRange: "0, 100",
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._chancePercentage;
  }
  get currencyKey() {
    if (!this._currencyKey) {
      this._currencyKey = {
        name: "currencyKey",
        Name: "CurrencyKey",
        number: 3,
        protoType: 9,
        protoName: "currency_key",
        type: JsonToString,
        options: {
          valueDropdown: "RewardItemKeyList",
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._currencyKey;
  }
  get unitPrice() {
    if (!this._unitPrice) {
      this._unitPrice = {
        name: "unitPrice",
        Name: "UnitPrice",
        number: 4,
        protoType: 5,
        protoName: "unit_price",
        type: JsonToInt32,
        options: {
          min: 0,
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._unitPrice;
  }
  get totalAmount() {
    if (!this._totalAmount) {
      this._totalAmount = {
        name: "totalAmount",
        Name: "TotalAmount",
        number: 5,
        protoType: 5,
        protoName: "total_amount",
        type: JsonToInt32,
        options: {
          min: 1,
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._totalAmount;
  }
  get totalPriceOverride() {
    if (!this._totalPriceOverride) {
      this._totalPriceOverride = {
        name: "totalPriceOverride",
        Name: "TotalPriceOverride",
        number: 6,
        protoType: 5,
        protoName: "total_price_override",
        type: JsonToInt32,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._totalPriceOverride;
  }
  get fields() {
    if (!this._fields) {
      this._fields = [
        this.itemKey,
        this.chancePercentage,
        this.currencyKey,
        this.unitPrice,
        this.totalAmount,
        this.totalPriceOverride,
      ];
    }
    return this._fields;
  }
  get oneofs() {
    if (!this._oneofs) {
      this._oneofs = [];
      this._oneofs.push({
        name: "dummyOneofForItemKey",
        Name: "DummyOneofForItemKey",
        fields: [
          this.fields[0],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForChancePercentage",
        Name: "DummyOneofForChancePercentage",
        fields: [
          this.fields[1],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForCurrencyKey",
        Name: "DummyOneofForCurrencyKey",
        fields: [
          this.fields[2],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForUnitPrice",
        Name: "DummyOneofForUnitPrice",
        fields: [
          this.fields[3],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForTotalAmount",
        Name: "DummyOneofForTotalAmount",
        fields: [
          this.fields[4],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForTotalPriceOverride",
        Name: "DummyOneofForTotalPriceOverride",
        fields: [
          this.fields[5],
        ],
      });
    }
    return this._oneofs;
  }
}
MarketData_Item.descriptor = new MarketData_Item_Descriptor();
class MarketData_Slot {
  get descriptor() {
    return MarketData_Slot.descriptor;
  }
  constructor(other) {
    if (other != null) {
      Object.assign(this, other);
      return;
    }
    this._items = [];
  }
  isEmpty() {
    if (this._items.length > 0) return false;
    return true;
  }
  static fromAny(value) {
    if (value instanceof MarketData_Slot) {
      return value;
    }
    return MarketData_Slot.fromJson(value);
  }
  static fromJson(json) {
    const result = new MarketData_Slot();
    result._items = JsonToList(json.items, MarketData_Item);
    return result;
  }
  static toJson(value) {
    return value.toJson();
  }
  toJson() {
    const result = {};
    if (this._items.length > 0) {
      result.items = ArrayToJson(this._items, MarketData_Item);
    }
    return result;
  }
  /**
   * @returns {MarketData_Item[]}
   */
  get items() {
    return this._items;
  }
  addItems(path, value) {
    return {type: 'ADD', path: path.concat(['items']), value: value.toJson()};
  }
  setItems(path, value) {
    return {type: 'SET', path: path.concat(['items']), value: ArrayToJson(value, MarketData_Item)};
  }
  setItemsByIndex(path, key, value) {
    return {type: 'SET', path: path.concat(['items', key]), value: value.toJson()};
  }
  deleteItems(path) {
    return {type: 'DELETE', path: path.concat(['items'])};
  }
  deleteItemsByIndex(path, key) {
    return {type: 'DELETE', path: path.concat(['items', key])};
  }
  apply(type, path, value) {
    if (path.length === 0) {
      return this;
    }
    switch (path[0]) {
      case "items": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new MarketData_Slot(this);
              copy._items = [];        for (let i of value) {
                copy._items.push(MarketData_Item.fromAny(i));
              }
              return copy;
            }
            case 'ADD': {
              const copy = new MarketData_Slot(this);
              copy._items = copy._items.concat([MarketData_Item.fromAny(value)]);
              return copy;
            }
            case 'DELETE': {
              if (this._items.length === 0) {
                return this;
              }
              const copy = new MarketData_Slot(this);
              copy._items = [];
              return copy;
            }
            default:
              return this;
          }
        } else if (path.length === 2) {
          const key = path[1];
          if (key < 0 || key >= this._items.length) {
            return this;
          }
          switch (type) {
            case 'SET': {
              const copy = new MarketData_Slot(this);
              copy._items = copy._items.slice();
              copy._items[path[1]] = MarketData_Item.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              const copy = new MarketData_Slot(this);
              copy._items = copy._items.slice(0, path[1]).concat(copy._items.slice(path[1] + 1));
              return copy;
            }
            default:
              return this;
          }
        } else {
          const key = path[1];
          if (key < 0 || key >= this._items.length) {
            return this;
          }
          const oldValue = this._items[key];
          const newValue = oldValue.apply(type, path.slice(2), value);
          if (oldValue === newValue) {
            return this;
          }
          const copy = new MarketData_Slot(this);
          copy._items = copy._items.slice();
          copy._items[key] = newValue;
          return copy;
        }
      }
      default:
        return this;
    }
  }
  /**
   * @param {MarketData_Slot} other
   * @returns {MarketData_Slot}
   */
  merge(other) {
    const copy = new MarketData_Slot(this);
    copy._items = this._items.concat(other._items);
    return copy;
  }
}
MarketData_Slot.default = new MarketData_Slot();
class MarketData_Slot_Builder {
  constructor(value) {
    this._value = new MarketData_Slot(value);
  }
  build() {
    return new MarketData_Slot(this._value);
  }
  addAllItems(values) {
    this._value._items = this._value._items.concat(values);
    return this;
  }
  addItems(value) {
    this._value._items = this._value._items.concat([value]);
    return this;
  }
  setItems(index, value) {
    this._value._items = this._value._items.concat();
    this._value._items[index] = value;
    return this;
  }
  clearItems() {
    this._value._items = [];
    return this;
  }
}
MarketData_Slot.Builder = MarketData_Slot_Builder;
class MarketData_Slot_WithParent {
  /**
   * @param {MarketData_Slot} value
   * @param {MarketData_Slot_WithParent} parent
   */
  constructor(value, parent) {
    this._value = value;
    this._parent = parent || null;
  }
  get descriptor() {
    return MarketData_Slot.descriptor;
  }
  get selfValue() {
    return this._value;
  }
  get parentValue() {
    return this._parent;
  }
  get selfItems() {
    if (!this._selfItems) {
      this._selfItems = [];
      for (let i of this._value.items) {
        this._selfItems.push(new MarketData_Item.WithParent(i, null));
      }
    }
    return this._selfItems;
  }
  get inherentItems() {
    if (!this._inherentItems) {
      this._inherentItems = this._parent ? this._parent.items : [];
    }
    return this._inherentItems;
  }
  get items() {
    if (!this._allItems) {
      this._allItems = this._parent ? this._parent.items.concat(this.selfItems) : this.selfItems;
    }
    return this._allItems;
  }
  update(current, parent) {
    const result = new MarketData_Slot_WithParent(current, parent);
    if (this._selfItems) {
      if (this._value.items === current.items) {
        result._selfItems = this._selfItems;
      } else {
        result._selfItems = [];
        for (let i = 0; i < current.items.length; i++) {
          const oldValue = this._value.items[i];
          if (oldValue) {
            const oldCache = this._selfItems[i];
            if (oldValue === current.items[i]) {
              result._selfItems[i] = oldCache;
            } else {
              result._selfItems[i] = oldCache.update(current.items[i], null);
            }
          } else {
            result._selfItems[i] = new MarketData_Item.WithParent(current.items[i], null);
          }
        }
      }
    }
    return result;
  }
}
MarketData_Slot_WithParent.default = new MarketData_Slot_WithParent(MarketData_Slot.default, null);
MarketData_Slot.WithParent = MarketData_Slot_WithParent;
class MarketData_Slot_Descriptor {
  get items() {
    if (!this._items) {
      this._items = {
        name: "items",
        Name: "Items",
        number: 1,
        protoType: 11,
        protoName: "items",
        type: MarketData_Item,
        isRepeated: true,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._items;
  }
  get fields() {
    if (!this._fields) {
      this._fields = [
        this.items,
      ];
    }
    return this._fields;
  }
  get oneofs() {
    if (!this._oneofs) {
      this._oneofs = [];
    }
    return this._oneofs;
  }
}
MarketData_Slot.descriptor = new MarketData_Slot_Descriptor();
class MarketData_SlotGroup {
  get descriptor() {
    return MarketData_SlotGroup.descriptor;
  }
  constructor(other) {
    if (other != null) {
      Object.assign(this, other);
      return;
    }
    this._hasFilter = false;
    this._filter = null;
    this._slots = [];
  }
  isEmpty() {
    if (this._hasFilter && !this._filter.isEmpty()) return false;
    if (this._slots.length > 0) return false;
    return true;
  }
  static fromAny(value) {
    if (value instanceof MarketData_SlotGroup) {
      return value;
    }
    return MarketData_SlotGroup.fromJson(value);
  }
  static fromJson(json) {
    const result = new MarketData_SlotGroup();
    if (json.filter != null) {
      result._hasFilter = true;
      result._filter = MarketData_Filter.fromJson(json.filter);
    }
    result._slots = JsonToList(json.slots, MarketData_Slot);
    return result;
  }
  static toJson(value) {
    return value.toJson();
  }
  toJson() {
    const result = {};
    if (this._hasFilter && !this._filter.isEmpty()) {
      result.filter = MarketData_Filter.toJson(this._filter);
    }
    if (this._slots.length > 0) {
      result.slots = ArrayToJson(this._slots, MarketData_Slot);
    }
    return result;
  }
  /**
   * @returns {MarketData_Filter}
   */
  get filter() {
    return this._hasFilter ? this._filter : MarketData_Filter.default;
  }
  get hasFilter() {
    return this._hasFilter;
  }
  setFilter(path, value) {
    return {type: 'SET', path: path.concat(['filter']), value: value.toJson()};
  }
  deleteFilter(path) {
    return {type: 'DELETE', path: path.concat(['filter'])};
  }
  /**
   * @returns {MarketData_Slot[]}
   */
  get slots() {
    return this._slots;
  }
  addSlots(path, value) {
    return {type: 'ADD', path: path.concat(['slots']), value: value.toJson()};
  }
  setSlots(path, value) {
    return {type: 'SET', path: path.concat(['slots']), value: ArrayToJson(value, MarketData_Slot)};
  }
  setSlotsByIndex(path, key, value) {
    return {type: 'SET', path: path.concat(['slots', key]), value: value.toJson()};
  }
  deleteSlots(path) {
    return {type: 'DELETE', path: path.concat(['slots'])};
  }
  deleteSlotsByIndex(path, key) {
    return {type: 'DELETE', path: path.concat(['slots', key])};
  }
  apply(type, path, value) {
    if (path.length === 0) {
      return this;
    }
    switch (path[0]) {
      case "filter": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new MarketData_SlotGroup(this);
              copy._hasFilter = true;
              copy._filter = MarketData_Filter.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasFilter) {
                return this;
              }
              const copy = new MarketData_SlotGroup(this);
              copy._hasFilter = false;
              copy._filter = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          if (!this._hasFilter) {
            const copy = new MarketData_SlotGroup(this);
            copy._hasFilter = true;
            copy._filter = MarketData_Filter.default.apply(type, path.slice(1), value);
            return copy;
          }
          const newValue = this._filter.apply(type, path.slice(1), value);
          if (newValue === this._filter) {
            return this;
          }
          const copy = new MarketData_SlotGroup(this);
          copy._filter = copy._filter.apply(type, path.slice(1), value);
          return copy;
        }
      }
      case "slots": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new MarketData_SlotGroup(this);
              copy._slots = [];        for (let i of value) {
                copy._slots.push(MarketData_Slot.fromAny(i));
              }
              return copy;
            }
            case 'ADD': {
              const copy = new MarketData_SlotGroup(this);
              copy._slots = copy._slots.concat([MarketData_Slot.fromAny(value)]);
              return copy;
            }
            case 'DELETE': {
              if (this._slots.length === 0) {
                return this;
              }
              const copy = new MarketData_SlotGroup(this);
              copy._slots = [];
              return copy;
            }
            default:
              return this;
          }
        } else if (path.length === 2) {
          const key = path[1];
          if (key < 0 || key >= this._slots.length) {
            return this;
          }
          switch (type) {
            case 'SET': {
              const copy = new MarketData_SlotGroup(this);
              copy._slots = copy._slots.slice();
              copy._slots[path[1]] = MarketData_Slot.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              const copy = new MarketData_SlotGroup(this);
              copy._slots = copy._slots.slice(0, path[1]).concat(copy._slots.slice(path[1] + 1));
              return copy;
            }
            default:
              return this;
          }
        } else {
          const key = path[1];
          if (key < 0 || key >= this._slots.length) {
            return this;
          }
          const oldValue = this._slots[key];
          const newValue = oldValue.apply(type, path.slice(2), value);
          if (oldValue === newValue) {
            return this;
          }
          const copy = new MarketData_SlotGroup(this);
          copy._slots = copy._slots.slice();
          copy._slots[key] = newValue;
          return copy;
        }
      }
      default:
        return this;
    }
  }
  /**
   * @param {MarketData_SlotGroup} other
   * @returns {MarketData_SlotGroup}
   */
  merge(other) {
    const copy = new MarketData_SlotGroup(this);
    if (other._hasFilter) {
      if (copy._hasFilter) {
        copy._filter = copy.filter.merge(other.filter);
      } else {
        copy._filter = other._filter;
      }
      copy._hasFilter = true;
    }
    copy._slots = this._slots.concat(other._slots);
    return copy;
  }
}
MarketData_SlotGroup.default = new MarketData_SlotGroup();
class MarketData_SlotGroup_Builder {
  constructor(value) {
    this._value = new MarketData_SlotGroup(value);
  }
  build() {
    return new MarketData_SlotGroup(this._value);
  }
  setFilter(value) {
    this._value._hasFilter = true;
    this._value._filter = value;
    return this;
  }
  deleteFilter() {
    this._value._hasFilter = false;
    this._value._filter = null;
    return this;
  }
  addAllSlots(values) {
    this._value._slots = this._value._slots.concat(values);
    return this;
  }
  addSlots(value) {
    this._value._slots = this._value._slots.concat([value]);
    return this;
  }
  setSlots(index, value) {
    this._value._slots = this._value._slots.concat();
    this._value._slots[index] = value;
    return this;
  }
  clearSlots() {
    this._value._slots = [];
    return this;
  }
}
MarketData_SlotGroup.Builder = MarketData_SlotGroup_Builder;
class MarketData_SlotGroup_WithParent {
  /**
   * @param {MarketData_SlotGroup} value
   * @param {MarketData_SlotGroup_WithParent} parent
   */
  constructor(value, parent) {
    this._value = value;
    this._parent = parent || null;
  }
  get descriptor() {
    return MarketData_SlotGroup.descriptor;
  }
  get selfValue() {
    return this._value;
  }
  get parentValue() {
    return this._parent;
  }
  get hasFilter() {
    if (this._cachedHasFilter === undefined) {
      if (this._value.hasFilter) {
        this._cachedHasFilter = true;
      } else {
        this._cachedHasFilter = this._parent ? this._parent.hasFilter : false;
      }
    }
    return this._cachedHasFilter;
  }
  get filter() {
    if (!this._cachedFilter) {
      if (this._value.hasFilter) {
        this._cachedFilter = new MarketData_Filter.WithParent(this._value.filter, this._parent && this._parent.hasFilter ? this._parent.filter : null);
      } else {
        this._cachedFilter = this._parent ? new MarketData_Filter.WithParent(MarketData_Filter.default, this._parent.filter) : MarketData_Filter.WithParent.default;
      }
    }
    return this._cachedFilter;
  }
  get selfSlots() {
    if (!this._selfSlots) {
      this._selfSlots = [];
      for (let i of this._value.slots) {
        this._selfSlots.push(new MarketData_Slot.WithParent(i, null));
      }
    }
    return this._selfSlots;
  }
  get inherentSlots() {
    if (!this._inherentSlots) {
      this._inherentSlots = this._parent ? this._parent.slots : [];
    }
    return this._inherentSlots;
  }
  get slots() {
    if (!this._allSlots) {
      this._allSlots = this._parent ? this._parent.slots.concat(this.selfSlots) : this.selfSlots;
    }
    return this._allSlots;
  }
  update(current, parent) {
    const result = new MarketData_SlotGroup_WithParent(current, parent);
    if (this._cachedFilter && this._value.hasFilter && current.hasFilter) {
      if (this._value.filter === current.filter && this._parent === parent) {
        result._cachedFilter = this._cachedFilter;
      } else {
        result._cachedFilter = this._cachedFilter.update(current.filter, parent && parent.hasFilter ? parent.filter : null);
      }
    }
    if (this._selfSlots) {
      if (this._value.slots === current.slots) {
        result._selfSlots = this._selfSlots;
      } else {
        result._selfSlots = [];
        for (let i = 0; i < current.slots.length; i++) {
          const oldValue = this._value.slots[i];
          if (oldValue) {
            const oldCache = this._selfSlots[i];
            if (oldValue === current.slots[i]) {
              result._selfSlots[i] = oldCache;
            } else {
              result._selfSlots[i] = oldCache.update(current.slots[i], null);
            }
          } else {
            result._selfSlots[i] = new MarketData_Slot.WithParent(current.slots[i], null);
          }
        }
      }
    }
    return result;
  }
}
MarketData_SlotGroup_WithParent.default = new MarketData_SlotGroup_WithParent(MarketData_SlotGroup.default, null);
MarketData_SlotGroup.WithParent = MarketData_SlotGroup_WithParent;
class MarketData_SlotGroup_Descriptor {
  get filter() {
    if (!this._filter) {
      this._filter = {
        name: "filter",
        Name: "Filter",
        number: 1,
        protoType: 11,
        protoName: "filter",
        type: MarketData_Filter,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._filter;
  }
  get slots() {
    if (!this._slots) {
      this._slots = {
        name: "slots",
        Name: "Slots",
        number: 2,
        protoType: 11,
        protoName: "slots",
        type: MarketData_Slot,
        isRepeated: true,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._slots;
  }
  get fields() {
    if (!this._fields) {
      this._fields = [
        this.filter,
        this.slots,
      ];
    }
    return this._fields;
  }
  get oneofs() {
    if (!this._oneofs) {
      this._oneofs = [];
      this._oneofs.push({
        name: "dummyOneofForFilter",
        Name: "DummyOneofForFilter",
        fields: [
          this.fields[0],
        ],
      });
    }
    return this._oneofs;
  }
}
MarketData_SlotGroup.descriptor = new MarketData_SlotGroup_Descriptor();
class MarketData_Tab {
  get descriptor() {
    return MarketData_Tab.descriptor;
  }
  constructor(other) {
    if (other != null) {
      Object.assign(this, other);
      return;
    }
    this._hasKey = false;
    this._key = null;
    this._hasDisplayName = false;
    this._displayName = null;
    this._hasTabRefreshInfo = false;
    this._tabRefreshInfo = null;
    this._slotGroup = [];
    this._hasMarketStoreType = false;
    this._marketStoreType = null;
  }
  isEmpty() {
    if (this._hasKey) return false;
    if (this._hasDisplayName) return false;
    if (this._hasTabRefreshInfo && !this._tabRefreshInfo.isEmpty()) return false;
    if (this._slotGroup.length > 0) return false;
    if (this._hasMarketStoreType) return false;
    return true;
  }
  static fromAny(value) {
    if (value instanceof MarketData_Tab) {
      return value;
    }
    return MarketData_Tab.fromJson(value);
  }
  static fromJson(json) {
    const result = new MarketData_Tab();
    if (json.key != null) {
      result._hasKey = true;
      result._key = JsonToString.fromJson(json.key);
    }
    if (json.displayName != null) {
      result._hasDisplayName = true;
      result._displayName = JsonToString.fromJson(json.displayName);
    }
    if (json.tabRefreshInfo != null) {
      result._hasTabRefreshInfo = true;
      result._tabRefreshInfo = MarketData_TabRefreshInfo.fromJson(json.tabRefreshInfo);
    }
    result._slotGroup = JsonToList(json.slotGroup, MarketData_SlotGroup);
    if (json.marketStoreType != null) {
      result._hasMarketStoreType = true;
      result._marketStoreType = MarketData_MarketStoreType.fromJson(json.marketStoreType);
    }
    return result;
  }
  static toJson(value) {
    return value.toJson();
  }
  toJson() {
    const result = {};
    if (this._hasKey) {
      result.key = JsonToString.toJson(this._key);
    }
    if (this._hasDisplayName) {
      result.displayName = JsonToString.toJson(this._displayName);
    }
    if (this._hasTabRefreshInfo && !this._tabRefreshInfo.isEmpty()) {
      result.tabRefreshInfo = MarketData_TabRefreshInfo.toJson(this._tabRefreshInfo);
    }
    if (this._slotGroup.length > 0) {
      result.slotGroup = ArrayToJson(this._slotGroup, MarketData_SlotGroup);
    }
    if (this._hasMarketStoreType) {
      result.marketStoreType = MarketData_MarketStoreType.toJson(this._marketStoreType);
    }
    return result;
  }
  /**
   * @returns {string}
   */
  get key() {
    return this._hasKey ? this._key : JsonToString.default;
  }
  get hasKey() {
    return this._hasKey;
  }
  setKey(path, value) {
    return {type: 'SET', path: path.concat(['key']), value};
  }
  deleteKey(path) {
    return {type: 'DELETE', path: path.concat(['key'])};
  }
  /**
   * @returns {string}
   */
  get displayName() {
    return this._hasDisplayName ? this._displayName : JsonToString.default;
  }
  get hasDisplayName() {
    return this._hasDisplayName;
  }
  setDisplayName(path, value) {
    return {type: 'SET', path: path.concat(['displayName']), value};
  }
  deleteDisplayName(path) {
    return {type: 'DELETE', path: path.concat(['displayName'])};
  }
  /**
   * @returns {MarketData_TabRefreshInfo}
   */
  get tabRefreshInfo() {
    return this._hasTabRefreshInfo ? this._tabRefreshInfo : MarketData_TabRefreshInfo.default;
  }
  get hasTabRefreshInfo() {
    return this._hasTabRefreshInfo;
  }
  setTabRefreshInfo(path, value) {
    return {type: 'SET', path: path.concat(['tabRefreshInfo']), value: value.toJson()};
  }
  deleteTabRefreshInfo(path) {
    return {type: 'DELETE', path: path.concat(['tabRefreshInfo'])};
  }
  /**
   * @returns {MarketData_SlotGroup[]}
   */
  get slotGroup() {
    return this._slotGroup;
  }
  addSlotGroup(path, value) {
    return {type: 'ADD', path: path.concat(['slotGroup']), value: value.toJson()};
  }
  setSlotGroup(path, value) {
    return {type: 'SET', path: path.concat(['slotGroup']), value: ArrayToJson(value, MarketData_SlotGroup)};
  }
  setSlotGroupByIndex(path, key, value) {
    return {type: 'SET', path: path.concat(['slotGroup', key]), value: value.toJson()};
  }
  deleteSlotGroup(path) {
    return {type: 'DELETE', path: path.concat(['slotGroup'])};
  }
  deleteSlotGroupByIndex(path, key) {
    return {type: 'DELETE', path: path.concat(['slotGroup', key])};
  }
  /**
   * @returns {number}
   */
  get marketStoreType() {
    return this._hasMarketStoreType ? this._marketStoreType : MarketData_MarketStoreType.default;
  }
  get hasMarketStoreType() {
    return this._hasMarketStoreType;
  }
  setMarketStoreType(path, value) {
    return {type: 'SET', path: path.concat(['marketStoreType']), value};
  }
  deleteMarketStoreType(path) {
    return {type: 'DELETE', path: path.concat(['marketStoreType'])};
  }
  apply(type, path, value) {
    if (path.length === 0) {
      return this;
    }
    switch (path[0]) {
      case "key": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new MarketData_Tab(this);
              copy._hasKey = true;
              copy._key = JsonToString.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasKey) {
                return this;
              }
              const copy = new MarketData_Tab(this);
              copy._hasKey = false;
              copy._key = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "displayName": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new MarketData_Tab(this);
              copy._hasDisplayName = true;
              copy._displayName = JsonToString.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasDisplayName) {
                return this;
              }
              const copy = new MarketData_Tab(this);
              copy._hasDisplayName = false;
              copy._displayName = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "tabRefreshInfo": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new MarketData_Tab(this);
              copy._hasTabRefreshInfo = true;
              copy._tabRefreshInfo = MarketData_TabRefreshInfo.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasTabRefreshInfo) {
                return this;
              }
              const copy = new MarketData_Tab(this);
              copy._hasTabRefreshInfo = false;
              copy._tabRefreshInfo = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          if (!this._hasTabRefreshInfo) {
            const copy = new MarketData_Tab(this);
            copy._hasTabRefreshInfo = true;
            copy._tabRefreshInfo = MarketData_TabRefreshInfo.default.apply(type, path.slice(1), value);
            return copy;
          }
          const newValue = this._tabRefreshInfo.apply(type, path.slice(1), value);
          if (newValue === this._tabRefreshInfo) {
            return this;
          }
          const copy = new MarketData_Tab(this);
          copy._tabRefreshInfo = copy._tabRefreshInfo.apply(type, path.slice(1), value);
          return copy;
        }
      }
      case "slotGroup": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new MarketData_Tab(this);
              copy._slotGroup = [];        for (let i of value) {
                copy._slotGroup.push(MarketData_SlotGroup.fromAny(i));
              }
              return copy;
            }
            case 'ADD': {
              const copy = new MarketData_Tab(this);
              copy._slotGroup = copy._slotGroup.concat([MarketData_SlotGroup.fromAny(value)]);
              return copy;
            }
            case 'DELETE': {
              if (this._slotGroup.length === 0) {
                return this;
              }
              const copy = new MarketData_Tab(this);
              copy._slotGroup = [];
              return copy;
            }
            default:
              return this;
          }
        } else if (path.length === 2) {
          const key = path[1];
          if (key < 0 || key >= this._slotGroup.length) {
            return this;
          }
          switch (type) {
            case 'SET': {
              const copy = new MarketData_Tab(this);
              copy._slotGroup = copy._slotGroup.slice();
              copy._slotGroup[path[1]] = MarketData_SlotGroup.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              const copy = new MarketData_Tab(this);
              copy._slotGroup = copy._slotGroup.slice(0, path[1]).concat(copy._slotGroup.slice(path[1] + 1));
              return copy;
            }
            default:
              return this;
          }
        } else {
          const key = path[1];
          if (key < 0 || key >= this._slotGroup.length) {
            return this;
          }
          const oldValue = this._slotGroup[key];
          const newValue = oldValue.apply(type, path.slice(2), value);
          if (oldValue === newValue) {
            return this;
          }
          const copy = new MarketData_Tab(this);
          copy._slotGroup = copy._slotGroup.slice();
          copy._slotGroup[key] = newValue;
          return copy;
        }
      }
      case "marketStoreType": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new MarketData_Tab(this);
              copy._hasMarketStoreType = true;
              copy._marketStoreType = MarketData_MarketStoreType.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasMarketStoreType) {
                return this;
              }
              const copy = new MarketData_Tab(this);
              copy._hasMarketStoreType = false;
              copy._marketStoreType = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      default:
        return this;
    }
  }
  /**
   * @param {MarketData_Tab} other
   * @returns {MarketData_Tab}
   */
  merge(other) {
    const copy = new MarketData_Tab(this);
    if (other._hasKey) {
      copy._hasKey = true;
      copy._key = other._key;
    }
    if (other._hasDisplayName) {
      copy._hasDisplayName = true;
      copy._displayName = other._displayName;
    }
    if (other._hasTabRefreshInfo) {
      if (copy._hasTabRefreshInfo) {
        copy._tabRefreshInfo = copy.tabRefreshInfo.merge(other.tabRefreshInfo);
      } else {
        copy._tabRefreshInfo = other._tabRefreshInfo;
      }
      copy._hasTabRefreshInfo = true;
    }
    copy._slotGroup = this._slotGroup.concat(other._slotGroup);
    if (other._hasMarketStoreType) {
      copy._hasMarketStoreType = true;
      copy._marketStoreType = other._marketStoreType;
    }
    return copy;
  }
}
MarketData_Tab.default = new MarketData_Tab();
class MarketData_Tab_Builder {
  constructor(value) {
    this._value = new MarketData_Tab(value);
  }
  build() {
    return new MarketData_Tab(this._value);
  }
  setKey(value) {
    this._value._hasKey = true;
    this._value._key = value;
    return this;
  }
  deleteKey() {
    this._value._hasKey = false;
    this._value._key = null;
    return this;
  }
  setDisplayName(value) {
    this._value._hasDisplayName = true;
    this._value._displayName = value;
    return this;
  }
  deleteDisplayName() {
    this._value._hasDisplayName = false;
    this._value._displayName = null;
    return this;
  }
  setTabRefreshInfo(value) {
    this._value._hasTabRefreshInfo = true;
    this._value._tabRefreshInfo = value;
    return this;
  }
  deleteTabRefreshInfo() {
    this._value._hasTabRefreshInfo = false;
    this._value._tabRefreshInfo = null;
    return this;
  }
  addAllSlotGroup(values) {
    this._value._slotGroup = this._value._slotGroup.concat(values);
    return this;
  }
  addSlotGroup(value) {
    this._value._slotGroup = this._value._slotGroup.concat([value]);
    return this;
  }
  setSlotGroup(index, value) {
    this._value._slotGroup = this._value._slotGroup.concat();
    this._value._slotGroup[index] = value;
    return this;
  }
  clearSlotGroup() {
    this._value._slotGroup = [];
    return this;
  }
  setMarketStoreType(value) {
    this._value._hasMarketStoreType = true;
    this._value._marketStoreType = value;
    return this;
  }
  deleteMarketStoreType() {
    this._value._hasMarketStoreType = false;
    this._value._marketStoreType = null;
    return this;
  }
}
MarketData_Tab.Builder = MarketData_Tab_Builder;
class MarketData_Tab_WithParent {
  /**
   * @param {MarketData_Tab} value
   * @param {MarketData_Tab_WithParent} parent
   */
  constructor(value, parent) {
    this._value = value;
    this._parent = parent || null;
  }
  get descriptor() {
    return MarketData_Tab.descriptor;
  }
  get selfValue() {
    return this._value;
  }
  get parentValue() {
    return this._parent;
  }
  get hasKey() {
    if (this._cachedHasKey === undefined) {
      if (this._value.hasKey) {
        this._cachedHasKey = true;
      } else {
        this._cachedHasKey = this._parent ? this._parent.hasKey : false;
      }
    }
    return this._cachedHasKey;
  }
  get key() {
    if (this._cachedKey === undefined) {
      if (this._value.hasKey) {
        this._cachedKey = this._value.key;
      } else {
        this._cachedKey = this._parent ? this._parent.key : this._value.key;
      }
    }
    return this._cachedKey;
  }
  get hasDisplayName() {
    if (this._cachedHasDisplayName === undefined) {
      if (this._value.hasDisplayName) {
        this._cachedHasDisplayName = true;
      } else {
        this._cachedHasDisplayName = this._parent ? this._parent.hasDisplayName : false;
      }
    }
    return this._cachedHasDisplayName;
  }
  get displayName() {
    if (this._cachedDisplayName === undefined) {
      if (this._value.hasDisplayName) {
        this._cachedDisplayName = this._value.displayName;
      } else {
        this._cachedDisplayName = this._parent ? this._parent.displayName : this._value.displayName;
      }
    }
    return this._cachedDisplayName;
  }
  get hasTabRefreshInfo() {
    if (this._cachedHasTabRefreshInfo === undefined) {
      if (this._value.hasTabRefreshInfo) {
        this._cachedHasTabRefreshInfo = true;
      } else {
        this._cachedHasTabRefreshInfo = this._parent ? this._parent.hasTabRefreshInfo : false;
      }
    }
    return this._cachedHasTabRefreshInfo;
  }
  get tabRefreshInfo() {
    if (!this._cachedTabRefreshInfo) {
      if (this._value.hasTabRefreshInfo) {
        this._cachedTabRefreshInfo = new MarketData_TabRefreshInfo.WithParent(this._value.tabRefreshInfo, this._parent && this._parent.hasTabRefreshInfo ? this._parent.tabRefreshInfo : null);
      } else {
        this._cachedTabRefreshInfo = this._parent ? new MarketData_TabRefreshInfo.WithParent(MarketData_TabRefreshInfo.default, this._parent.tabRefreshInfo) : MarketData_TabRefreshInfo.WithParent.default;
      }
    }
    return this._cachedTabRefreshInfo;
  }
  get selfSlotGroup() {
    if (!this._selfSlotGroup) {
      this._selfSlotGroup = [];
      for (let i of this._value.slotGroup) {
        this._selfSlotGroup.push(new MarketData_SlotGroup.WithParent(i, null));
      }
    }
    return this._selfSlotGroup;
  }
  get inherentSlotGroup() {
    if (!this._inherentSlotGroup) {
      this._inherentSlotGroup = this._parent ? this._parent.slotGroup : [];
    }
    return this._inherentSlotGroup;
  }
  get slotGroup() {
    if (!this._allSlotGroup) {
      this._allSlotGroup = this._parent ? this._parent.slotGroup.concat(this.selfSlotGroup) : this.selfSlotGroup;
    }
    return this._allSlotGroup;
  }
  get hasMarketStoreType() {
    if (this._cachedHasMarketStoreType === undefined) {
      if (this._value.hasMarketStoreType) {
        this._cachedHasMarketStoreType = true;
      } else {
        this._cachedHasMarketStoreType = this._parent ? this._parent.hasMarketStoreType : false;
      }
    }
    return this._cachedHasMarketStoreType;
  }
  get marketStoreType() {
    if (this._cachedMarketStoreType === undefined) {
      if (this._value.hasMarketStoreType) {
        this._cachedMarketStoreType = this._value.marketStoreType;
      } else {
        this._cachedMarketStoreType = this._parent ? this._parent.marketStoreType : this._value.marketStoreType;
      }
    }
    return this._cachedMarketStoreType;
  }
  update(current, parent) {
    const result = new MarketData_Tab_WithParent(current, parent);
    if (this._cachedTabRefreshInfo && this._value.hasTabRefreshInfo && current.hasTabRefreshInfo) {
      if (this._value.tabRefreshInfo === current.tabRefreshInfo && this._parent === parent) {
        result._cachedTabRefreshInfo = this._cachedTabRefreshInfo;
      } else {
        result._cachedTabRefreshInfo = this._cachedTabRefreshInfo.update(current.tabRefreshInfo, parent && parent.hasTabRefreshInfo ? parent.tabRefreshInfo : null);
      }
    }
    if (this._selfSlotGroup) {
      if (this._value.slotGroup === current.slotGroup) {
        result._selfSlotGroup = this._selfSlotGroup;
      } else {
        result._selfSlotGroup = [];
        for (let i = 0; i < current.slotGroup.length; i++) {
          const oldValue = this._value.slotGroup[i];
          if (oldValue) {
            const oldCache = this._selfSlotGroup[i];
            if (oldValue === current.slotGroup[i]) {
              result._selfSlotGroup[i] = oldCache;
            } else {
              result._selfSlotGroup[i] = oldCache.update(current.slotGroup[i], null);
            }
          } else {
            result._selfSlotGroup[i] = new MarketData_SlotGroup.WithParent(current.slotGroup[i], null);
          }
        }
      }
    }
    return result;
  }
}
MarketData_Tab_WithParent.default = new MarketData_Tab_WithParent(MarketData_Tab.default, null);
MarketData_Tab.WithParent = MarketData_Tab_WithParent;
class MarketData_Tab_Descriptor {
  get key() {
    if (!this._key) {
      this._key = {
        name: "key",
        Name: "Key",
        number: 1,
        protoType: 9,
        protoName: "key",
        type: JsonToString,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._key;
  }
  get displayName() {
    if (!this._displayName) {
      this._displayName = {
        name: "displayName",
        Name: "DisplayName",
        number: 2,
        protoType: 9,
        protoName: "display_name",
        type: JsonToString,
        options: {
          localization: true,
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._displayName;
  }
  get tabRefreshInfo() {
    if (!this._tabRefreshInfo) {
      this._tabRefreshInfo = {
        name: "tabRefreshInfo",
        Name: "TabRefreshInfo",
        number: 3,
        protoType: 11,
        protoName: "tab_refresh_info",
        type: MarketData_TabRefreshInfo,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._tabRefreshInfo;
  }
  get slotGroup() {
    if (!this._slotGroup) {
      this._slotGroup = {
        name: "slotGroup",
        Name: "SlotGroup",
        number: 4,
        protoType: 11,
        protoName: "slot_group",
        type: MarketData_SlotGroup,
        isRepeated: true,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._slotGroup;
  }
  get marketStoreType() {
    if (!this._marketStoreType) {
      this._marketStoreType = {
        name: "marketStoreType",
        Name: "MarketStoreType",
        number: 5,
        protoType: 14,
        protoName: "market_store_type",
        type: MarketData_MarketStoreType,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._marketStoreType;
  }
  get fields() {
    if (!this._fields) {
      this._fields = [
        this.key,
        this.displayName,
        this.tabRefreshInfo,
        this.slotGroup,
        this.marketStoreType,
      ];
    }
    return this._fields;
  }
  get oneofs() {
    if (!this._oneofs) {
      this._oneofs = [];
      this._oneofs.push({
        name: "dummyOneofForKey",
        Name: "DummyOneofForKey",
        fields: [
          this.fields[0],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForDisplayName",
        Name: "DummyOneofForDisplayName",
        fields: [
          this.fields[1],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForTabRefreshInfo",
        Name: "DummyOneofForTabRefreshInfo",
        fields: [
          this.fields[2],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForMarketStoreType",
        Name: "DummyOneofForMarketStoreType",
        fields: [
          this.fields[4],
        ],
      });
    }
    return this._oneofs;
  }
}
MarketData_Tab.descriptor = new MarketData_Tab_Descriptor();
class MarketData_MarketStoreType {
  static fromJson(json) {
    if (typeof json === "string") {
      switch (json) {
        case "AUTO_OPEN_AND_REFRESH": return 0;
        case "MANUAL_OPEN_AND_EXPIRE": return 1;
        default: return 0;
      }
    }
    return json;
  }
  static toJson(value) {
    return value;
  }
  static fromAny(value) {
    return MarketData_MarketStoreType.fromJson(value);
  }
  static fromReact(e) {
    return MarketData_MarketStoreType.fromJson(e);
  }
}
MarketData_MarketStoreType.AUTO_OPEN_AND_REFRESH = 0;
MarketData_MarketStoreType.MANUAL_OPEN_AND_EXPIRE = 1;
MarketData_MarketStoreType.default = 0;
MarketData_MarketStoreType.values = {
  AUTO_OPEN_AND_REFRESH: 0,
  MANUAL_OPEN_AND_EXPIRE: 1,
};
MarketData_MarketStoreType.names = {
  0: "AUTO_OPEN_AND_REFRESH",
  1: "MANUAL_OPEN_AND_EXPIRE",
};
export class MarketData {
  get descriptor() {
    return MarketData.descriptor;
  }
  constructor(other) {
    if (other != null) {
      Object.assign(this, other);
      return;
    }
    this._tabs = [];
  }
  isEmpty() {
    if (this._tabs.length > 0) return false;
    return true;
  }
  static fromAny(value) {
    if (value instanceof MarketData) {
      return value;
    }
    return MarketData.fromJson(value);
  }
  static fromJson(json) {
    const result = new MarketData();
    result._tabs = JsonToList(json.tabs, MarketData_Tab);
    return result;
  }
  static toJson(value) {
    return value.toJson();
  }
  toJson() {
    const result = {};
    if (this._tabs.length > 0) {
      result.tabs = ArrayToJson(this._tabs, MarketData_Tab);
    }
    return result;
  }
  /**
   * @returns {MarketData_Tab[]}
   */
  get tabs() {
    return this._tabs;
  }
  addTabs(path, value) {
    return {type: 'ADD', path: path.concat(['tabs']), value: value.toJson()};
  }
  setTabs(path, value) {
    return {type: 'SET', path: path.concat(['tabs']), value: ArrayToJson(value, MarketData_Tab)};
  }
  setTabsByIndex(path, key, value) {
    return {type: 'SET', path: path.concat(['tabs', key]), value: value.toJson()};
  }
  deleteTabs(path) {
    return {type: 'DELETE', path: path.concat(['tabs'])};
  }
  deleteTabsByIndex(path, key) {
    return {type: 'DELETE', path: path.concat(['tabs', key])};
  }
  apply(type, path, value) {
    if (path.length === 0) {
      return this;
    }
    switch (path[0]) {
      case "tabs": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new MarketData(this);
              copy._tabs = [];        for (let i of value) {
                copy._tabs.push(MarketData_Tab.fromAny(i));
              }
              return copy;
            }
            case 'ADD': {
              const copy = new MarketData(this);
              copy._tabs = copy._tabs.concat([MarketData_Tab.fromAny(value)]);
              return copy;
            }
            case 'DELETE': {
              if (this._tabs.length === 0) {
                return this;
              }
              const copy = new MarketData(this);
              copy._tabs = [];
              return copy;
            }
            default:
              return this;
          }
        } else if (path.length === 2) {
          const key = path[1];
          if (key < 0 || key >= this._tabs.length) {
            return this;
          }
          switch (type) {
            case 'SET': {
              const copy = new MarketData(this);
              copy._tabs = copy._tabs.slice();
              copy._tabs[path[1]] = MarketData_Tab.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              const copy = new MarketData(this);
              copy._tabs = copy._tabs.slice(0, path[1]).concat(copy._tabs.slice(path[1] + 1));
              return copy;
            }
            default:
              return this;
          }
        } else {
          const key = path[1];
          if (key < 0 || key >= this._tabs.length) {
            return this;
          }
          const oldValue = this._tabs[key];
          const newValue = oldValue.apply(type, path.slice(2), value);
          if (oldValue === newValue) {
            return this;
          }
          const copy = new MarketData(this);
          copy._tabs = copy._tabs.slice();
          copy._tabs[key] = newValue;
          return copy;
        }
      }
      default:
        return this;
    }
  }
  /**
   * @param {MarketData} other
   * @returns {MarketData}
   */
  merge(other) {
    const copy = new MarketData(this);
    copy._tabs = this._tabs.concat(other._tabs);
    return copy;
  }
}
MarketData.default = new MarketData();
MarketData.BindingTournament = MarketData_BindingTournament;
MarketData.Filter = MarketData_Filter;
MarketData.TabRefreshInfo = MarketData_TabRefreshInfo;
MarketData.Item = MarketData_Item;
MarketData.Slot = MarketData_Slot;
MarketData.SlotGroup = MarketData_SlotGroup;
MarketData.Tab = MarketData_Tab;
MarketData.MarketStoreType = MarketData_MarketStoreType;
class MarketData_Builder {
  constructor(value) {
    this._value = new MarketData(value);
  }
  build() {
    return new MarketData(this._value);
  }
  addAllTabs(values) {
    this._value._tabs = this._value._tabs.concat(values);
    return this;
  }
  addTabs(value) {
    this._value._tabs = this._value._tabs.concat([value]);
    return this;
  }
  setTabs(index, value) {
    this._value._tabs = this._value._tabs.concat();
    this._value._tabs[index] = value;
    return this;
  }
  clearTabs() {
    this._value._tabs = [];
    return this;
  }
}
MarketData.Builder = MarketData_Builder;
class MarketData_WithParent {
  /**
   * @param {MarketData} value
   * @param {MarketData_WithParent} parent
   */
  constructor(value, parent) {
    this._value = value;
    this._parent = parent || null;
  }
  get descriptor() {
    return MarketData.descriptor;
  }
  get selfValue() {
    return this._value;
  }
  get parentValue() {
    return this._parent;
  }
  get selfTabs() {
    if (!this._selfTabs) {
      this._selfTabs = [];
      for (let i of this._value.tabs) {
        this._selfTabs.push(new MarketData_Tab.WithParent(i, null));
      }
    }
    return this._selfTabs;
  }
  get inherentTabs() {
    if (!this._inherentTabs) {
      this._inherentTabs = this._parent ? this._parent.tabs : [];
    }
    return this._inherentTabs;
  }
  get tabs() {
    if (!this._allTabs) {
      this._allTabs = this._parent ? this._parent.tabs.concat(this.selfTabs) : this.selfTabs;
    }
    return this._allTabs;
  }
  update(current, parent) {
    const result = new MarketData_WithParent(current, parent);
    if (this._selfTabs) {
      if (this._value.tabs === current.tabs) {
        result._selfTabs = this._selfTabs;
      } else {
        result._selfTabs = [];
        for (let i = 0; i < current.tabs.length; i++) {
          const oldValue = this._value.tabs[i];
          if (oldValue) {
            const oldCache = this._selfTabs[i];
            if (oldValue === current.tabs[i]) {
              result._selfTabs[i] = oldCache;
            } else {
              result._selfTabs[i] = oldCache.update(current.tabs[i], null);
            }
          } else {
            result._selfTabs[i] = new MarketData_Tab.WithParent(current.tabs[i], null);
          }
        }
      }
    }
    return result;
  }
}
MarketData_WithParent.default = new MarketData_WithParent(MarketData.default, null);
MarketData.WithParent = MarketData_WithParent;
class MarketData_Descriptor {
  get tabs() {
    if (!this._tabs) {
      this._tabs = {
        name: "tabs",
        Name: "Tabs",
        number: 1,
        protoType: 11,
        protoName: "tabs",
        type: MarketData_Tab,
        isRepeated: true,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._tabs;
  }
  get fields() {
    if (!this._fields) {
      this._fields = [
        this.tabs,
      ];
    }
    return this._fields;
  }
  get oneofs() {
    if (!this._oneofs) {
      this._oneofs = [];
    }
    return this._oneofs;
  }
}
MarketData.descriptor = new MarketData_Descriptor();
